import React, {
  ReactElement,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  Button,
  Chip,
  CircularProgress,
  makeStyles,
  Modal,
  Radio,
  InputAdornment,
  IconButton,
  MenuItem,
  useMediaQuery,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import theme from "../../../themes";
import { RedirectUri, useEnumStrings } from "../../enumStrings";
import {
  CategoryAdvertisingBannersFeeOptionsInput,
  CategoryAdvertisingBannersFeeOptionsReturn,
  CategoryAdvertisingBannerActivationInfoReturn,
  ChamberMemberCategory,
  ChamberEngageSettingsReturn,
  GetAllChamberMembersQuery,
  UserType,
  useGetAllChamberMembersQuery,
  useActivateBannerForCategoryAdvertisingBannerMutation,
  useReactivateBannerForCategoryAdvertisingBannerMutation,
  useDeactivateBannerForCategoryAdvertisingBannerMutation,
  GetAllCategoryAdvertisingBannersForChamberDocument,
  useGetAllCategoryAdvertisingBannersForChamberQuery,
  GetAllCategoryAdvertisingBannersForChamberQuery,
  GetUser_RootAdminChamberAdminQuery,
  BannerInput,
  BannerContentTypeEnum,
  useUpdateBannerContentForCategoryAdvertisingBannerMutation,
  useChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutation,
} from "../../../graphql/types";
import Loader from "../../common/Loader/Loader";
import SuccessDialog from "../../common/SuccessDialog";
import ComingSoonDialog from "../../common/ComingSoonDialog";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { goldDatePickerTheme } from "../../../themes";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import Collapse from "@mui/material/Collapse";
import { visuallyHidden } from "@mui/utils";
import { TextField, FormControl, Select } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import FilterIcon from "../../../images/filter.png";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import ExportButton from "../../common/ExportButton";
import { openInstructionPdf } from "../../common/openInstructionPdf";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import LogoImage from "../../common/utilities/LogoImage";
import { useGetCategoryIdToHumanReadableName } from "../../common/Hooks/useGetCategoryIdToHumanReadableName";
import ArrowUp from "@material-ui/icons/KeyboardArrowUp";
import ArrowDown from "@material-ui/icons/KeyboardArrowDown";
import SortIcon from "../../../images/sort.png";
import { stableSort, getComparator, HeadCell } from "../../common/CommonTable";
import RESTAURANT from "../../../images/RESTAURANT.png";
import RETAIL from "../../../images/RETAIL.png";
import PERSONAL_SERVICES from "../../../images/PERSONAL_SERVICES.png";
import COMMUNICATION_TECHNOLOGY from "../../../images/COMMUNICATION_TECHNOLOGY.png";
import CONSTRUCTION_SUPPLIERS from "../../../images/CONSTRUCTION_SUPPLIERS.png";
import FINANCIAL from "../../../images/FINANCIAL.png";
import ACCOMMODATIONS_ATTRACTIONS from "../../../images/ACCOMMODATIONS_ATTRACTIONS.png";
import MARKETING_ADVERTISING from "../../../images/MARKETING_ADVERTISING.png";
import INDUSTRIES from "../../../images/INDUSTRIES.png";
import AUTOMOTIVE_TRANSPORTATION from "../../../images/AUTOMOTIVE_TRANSPORTATION.png";
import PROFESSIONAL_SERVICES from "../../../images/PROFESSIONAL_SERVICES.png";
import HEALTH_SAFETY from "../../../images/HEALTH_SAFETY.png";
import SPORTS_RECREATION from "../../../images/SPORTS_RECREATION.png";
import GOVERNMENT_EDUCATION from "../../../images/GOVERNMENT_EDUCATION.png";
import NON_PROFIT from "../../../images/NON_PROFIT.png";
import REAL_ESTATE from "../../../images/REAL_ESTATE.png";
import FARMING_AGRICULTURE from "../../../images/FARMING_AGRICULTURE.png";
import CONSTRUCTION_INDUSTRIAL from "../../../images/CONSTRUCTION_INDUSTRIAL.png";
import useGetChamberFromUserIdInAuth from "../../common/Hooks/useGetChamberFromUserIdInAuth";
import ChamberMemberSelector from "../ChamberMemberAdmin/ChamberMemberSelector";
import omitDeep from "omit-deep-lodash";
import { getLocalTimestamp } from "../Root/RootAdmin";
import { useHistory, useLocation } from "react-router-dom";
import { UserTypeContext } from "../../../UserTypeContext";
import BannerPicker from "../../common/BannerPicker";
import HoverToolTip from "../../common/utilities/HoverToolTip";
import cloneDeep from "lodash.clonedeep";
import AutoApproveBannerContentToggle from "../../common/utilities/AutoApproveBannerContentToggle";
import UilExportIcon from "../../../images/uil_export.png";
import EventIcon from "@material-ui/icons/Event";
import {
  activationFormStyles,
  FormLabel,
  FormDescription,
  InfoTextSection,
  AnnualFeeDisplay,
} from "../../common/ChamberEngageActivationForm";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import UploadRoundIcon from "../../../images/upload-rounded.png";
import VideoIcon from "../../../images/lets-icons_video.png";
import EditOrangeIcon from "../../../images/edit-icon-orange.png";
import TrashIcon from "../../../images/trash.png";
import BannerUploadModal from "./BannerUploadModal";
import BannerPreviewModal from "./BannerPreviewModal";
import DeleteBannerModal from "./DeleteBannerModal";
import CategoryBannerPhoneMockup from "../../../images/cateogrybanner.jpeg";
import VideoTutorialButton from "../../common/VideoTutorialButton";
import { showActionErrorNotice } from "../../common/ActionErrorNotice";

const categoryIdToLogo = {
  [ChamberMemberCategory.Restaurant]: RESTAURANT,
  [ChamberMemberCategory.Retail]: RETAIL,
  [ChamberMemberCategory.PersonalServices]: PERSONAL_SERVICES,
  [ChamberMemberCategory.CommunicationTechnology]: COMMUNICATION_TECHNOLOGY,
  [ChamberMemberCategory.ConstructionSuppliers]: CONSTRUCTION_SUPPLIERS, // delete when category migration done
  [ChamberMemberCategory.Financial]: FINANCIAL,
  [ChamberMemberCategory.AccommodationsAttractions]: ACCOMMODATIONS_ATTRACTIONS,
  [ChamberMemberCategory.MarketingAdvertising]: MARKETING_ADVERTISING,
  [ChamberMemberCategory.Industries]: INDUSTRIES, // delete when category migration done
  [ChamberMemberCategory.AutomotiveTransportation]: AUTOMOTIVE_TRANSPORTATION,
  [ChamberMemberCategory.ProfessionalServices]: PROFESSIONAL_SERVICES,
  [ChamberMemberCategory.HealthSafety]: HEALTH_SAFETY,
  [ChamberMemberCategory.SportsRecreation]: SPORTS_RECREATION,
  [ChamberMemberCategory.GovernmentEducation]: GOVERNMENT_EDUCATION,
  [ChamberMemberCategory.NonProfit]: NON_PROFIT,
  [ChamberMemberCategory.RealEstate]: REAL_ESTATE,
  [ChamberMemberCategory.FarmingAgriculture]: FARMING_AGRICULTURE,
  [ChamberMemberCategory.ConstructionIndustrial]: CONSTRUCTION_INDUSTRIAL,
};

enum SellModalTypeEnum {
  Sell = "Sell",
  Resell = "Resell",
  ViewResell = "ViewResell",
}

type AdvertisingFeesTableProps = {
  selectedAdvertisingOptionId: string | null;
  updatedCategoryAdvertisingBannerFeeOptions: FeeOptionsWithId[] | null;
  chamberInfo?: GetUser_RootAdminChamberAdminQuery["getUser"]["chamberInfo"];
};


const useStyles = makeStyles((themes: any) => ({
  headerSection: {
    backgroundColor: theme.palette.primary.main,
    padding: "30px 40px",
    minHeight: "200px",
    [theme.breakpoints.down("sm")]: {
      padding: "16px 16px",
      minHeight: "auto",
    },
  },
  titleRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "10px",
  },
  title: {
    fontSize: "32px",
    color: "white",
    fontWeight: "bold",
    margin: 0,
    [theme.breakpoints.down("sm")]: {
      fontSize: "24px",
    },
  },
  headerIcons: {
    display: "flex",
    gap: "15px",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  headerIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  description: {
    fontSize: "18px",
    color: "rgba(255, 255, 255, 0.9)",
    marginTop: "8px",
    lineHeight: "1.5",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      lineHeight: "1.55",
    },
  },
  buttonContainer: {
    display: "flex",
    gap: "15px",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: "8px",
      width: "100%",
      "& > div": { width: "100%" },
      "& > div > a, & > div > a > button, & > div > button, & > button, & > a": {
        width: "100%",
        marginTop: 0,
      },
    },
  },
  formSection: {
    maxWidth: "1040px",
    margin: "30px auto 30px auto",
    padding: "0px 30px 30px 30px",
    border: "2px dotted #CCC",
    borderRadius: "8px",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      padding: "0px 12px 16px 12px",
    },
  },
  sectionHeader: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: "25px",
    padding: "10px 30px",
    display: "inline-block",
    position: "relative",
    top: "-15px",
    left: "30px",
    [theme.breakpoints.down("sm")]: {
      left: "12px",
      padding: "8px 16px",
    },
  },
  sectionTitle: {
    color: "white",
    fontSize: "16px",
    fontWeight: 600,
    margin: 0,
  },
  sectionHelperText: {
    color: "#000000",
    fontSize: "16px",
    margin: "30px 30px 25px 30px",
    [theme.breakpoints.down("sm")]: {
      margin: "16px 0 12px 0",
    },
  },
  videoButton: {
    backgroundColor: "white",
    color: "#D4A353",
    fontWeight: "bold",
    borderRadius: "8px",
    padding: "10px 20px",
    textTransform: "none",
    fontSize: "14px",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  titleContent: {
    display: "flex",
    flexDirection: "column-reverse",
    backgroundColor: theme.palette.primary.main,
    [theme.breakpoints.up("lg")]: {
      paddingTop: "30px",
    },
  },
  contentContainer: {
    backgroundColor: "#D4A353",
    padding: "0 40px 40px 40px",
    overflowX: "hidden",
    [theme.breakpoints.down("sm")]: {
      padding: 0,
    },
  },
  content: {
    display: "flex",
    background: "#FFFFFF",
    minHeight: "70vh",
    borderRadius: "20px",
    padding: "30px",
    flexDirection: "column",
    overflowX: "hidden",
    [theme.breakpoints.down("sm")]: {
      padding: "14px",
      borderRadius: 0,
    },
  },
  searchContainer: {
    display: "flex",
    gap: "20px",
    alignItems: "center",
    marginBottom: "20px",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      gap: "10px",
    },
  },
  searchBar: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    width: "404px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    height: "45px",
    "& .MuiOutlinedInput-root": {
      height: "45px",
      borderRadius: "8px",

      fontSize: "14px",
      fontWeight: 500,
      padding: "8px 9px",
      "& fieldset": {
        borderColor: "#000000",
        borderWidth: "1px",
      },
      "&:hover fieldset": {
        borderColor: "#000000",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#000000 !important",
      },
    },
    "& .MuiOutlinedInput-input": {

      fontSize: "14px",
      fontWeight: 500,
      color: "#000",
      padding: "0",
      "&::placeholder": {
        color: "#9E9E9E",
        opacity: 1,
      },
    },
  },
  modal: {
    border: "unset",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: "966px",
    height: "auto",
    maxHeight: "90vh",
    borderRadius: "20px",
    textAlign: "center",
    maxWidth: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    backgroundColor: "#cfd8dc",
    padding: "30px 40px",
    position: "relative",
    overflow: "auto",
    [theme.breakpoints.down("sm")]: {
      padding: "16px",
      maxWidth: "100%",
      borderRadius: "12px",
    },
  },
  closeButton: {
    position: "absolute",
    top: "15px",
    right: "15px",
    backgroundColor: (theme.palette as any).delete.main,
    color: "white",
    width: "32px",
    height: "32px",
    "&:hover": {
      backgroundColor: "#C71920",
    },
  },
  modalTitle: {

    fontSize: "20px",
    fontWeight: "bold",
    lineHeight: "120%",
    margin: "0 0 10px 0",
    textAlign: "center",
  },
  modalContentBox: {
    width: "100%",
    border: "2px solid #9E9E9E",
    borderRadius: "10px",
    padding: "20px",
    marginBottom: "20px",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  modalBodyText: {

    fontSize: "18px",
    lineHeight: "180%",
    margin: "0 0 15px 0",
    textAlign: "left",
    width: "100%",
  },
  modalButtonContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    gap: "40px",
    width: "100%",
    paddingLeft: "30px",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0",
      gap: "16px",
      flexDirection: "column",
    },
  },
  yesButton: {
    width: "290px",
    height: "54px",
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff",
    fontWeight: "bold",
    textTransform: "uppercase",
    fontSize: "16px",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: "#d4a028",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  okButton: {
    width: "290px",
    height: "54px",
    backgroundColor: "#37474f",
    color: "#ffffff",
    fontWeight: "bold",
    textTransform: "uppercase",
    fontSize: "16px",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: "#2c3a40",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  radio: {
    color: `${theme.palette.primary.main}!important`,
    padding: 0,
    marginRight: 10,
    backgroundColor: "white",
  },
  filledDatePicker: {
    backgroundColor: "#F2F2F6",
    borderRadius: "15px",
    height: "55px",
    width: "100%",
    "& .MuiInputBase-root": {
      backgroundColor: "white !important",
      borderRadius: "15px !important",
    },
    "& .MuiInputLabel-filled.MuiInputLabel-shrink": {
      color: "#37474f",
    },
    "& .MuiInputBase-input.MuiFilledInput-input.Mui-disabled": {
      color: "black",
      opacity: 1,
      "-webkit-text-fill-color": "black",
    },
  },
  dropDownTableCell: {
    fontSize: "16px",
    borderBottom: "0px !important",
  },
  filterSelect: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    width: "auto",
    minWidth: "180px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      minWidth: "unset",
    },
    "&:focus, &:focus-visible": {
      outline: "none",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      "& fieldset": {
        borderColor: "#000000",
      },
      "&:hover fieldset": {
        borderColor: "#000000",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#000000 !important",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#000000 !important",
      },
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#000000 !important",
    },
    "& .MuiSelect-select": {
      paddingTop: "12px",
      paddingBottom: "12px",
      paddingRight: "32px",
      color: "#000",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    "& .MuiSelect-icon": {
      display: "none",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "8px",
      borderColor: "#000000 !important",
    }
  },
  // Banner card styles from EditChamberMember
  bannersGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "20px",
    marginTop: "20px",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr 1fr",
      gap: "12px",
    },
  },
  bannerCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: "10px",
    overflow: "hidden",
    border: `2px solid ${theme.palette.primary.main}`,
    display: "flex",
    flexDirection: "column" as const,
  },
  bannerImageContainer: {
    height: "120px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    position: "relative" as const,
  },
  bannerImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover" as const,
  },
  videoPlaceholder: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
    color: theme.palette.primary.main,
    fontSize: "20px",
    fontWeight: "bold",
  },
  bannerActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 10px",
    backgroundColor: "#FFFFFF",
  },
  editDeleteButtons: {
    display: "flex",
    gap: "8px",
  },
  editButton: {
    color: theme.palette.primary.main,
    padding: "4px",
    minWidth: "auto",
    "&:hover": {
      backgroundColor: "rgba(225, 167, 49, 0.1)",
    },
  },
  trashButton: {
    color: "#EF4444",
    padding: "4px",
    minWidth: "auto",
    "&:hover": {
      backgroundColor: "rgba(239, 68, 68, 0.1)",
    },
  },
  arrowButtons: {
    display: "flex",
    gap: "6px",
  },
  arrowButton: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    padding: "4px",
    borderRadius: "4px",
    minWidth: "28px",
    width: "28px",
    height: "28px",
    "&:hover": {
      backgroundColor: "#D4A353",
    },
    "&.Mui-disabled": {
      backgroundColor: "#E0E0E0",
      color: "#9E9E9E",
    },
  },
  previewButton: {
    backgroundColor: "#333",
    color: "white",
    fontSize: "16px",
    fontWeight: "bold",
    borderRadius: "25px",
    padding: "12px 40px",
    textTransform: "none" as const,
    marginTop: "20px",
    "&:hover": {
      backgroundColor: "#444",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px 20px",
      fontSize: "14px",
    },
  },
  bannerUploadRow: {
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "flex-start",
    gap: "12px",
    marginTop: "20px",
    width: "100%",
    marginBottom: "14px",
    [theme.breakpoints.down("sm")]: {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
    },
  },
  bannerStatusRow: {
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "center",
    gap: "12px",
    width: "100%",
    marginBottom: "24px",
    [theme.breakpoints.down("sm")]: {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
    },
  },
  modalButtonRowInline: {
    display: "flex",
    flexDirection: "row" as const,
    justifyContent: "center",
    gap: "40px",
    marginTop: "24px",
    [theme.breakpoints.down("sm")]: {
      gap: "10px",
      alignItems: "stretch",
      width: "100%",
    },
  },
  modalInlineButton: {
    color: "white",
    fontWeight: 600,
    textTransform: "uppercase" as const,
    padding: "15px 96px",
    borderRadius: "12px",
    width: "290px",
    height: "54px",
    fontSize: "18px",
    boxShadow: "none",
    letterSpacing: "-0.04em",
    [theme.breakpoints.down("sm")]: {
      flex: 1,
      width: "auto",
      minWidth: 0,
      padding: "12px 8px",
      fontSize: "14px",
    },
  },
  // Mobile card styles
  desktopTableWrapper: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  mobileCardWrapper: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  categoryMobileCard: {
    backgroundColor: "transparent",
    padding: "14px 0",
    borderBottom: "1px solid #E8E8E8",
  },
  catCardHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "12px",
  },
  catCardDivider: {
    display: "none",
  },
  catCardMemberRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    marginBottom: "8px",
  },
  catCardMemberAvatar: {
    width: "28px",
    height: "28px",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold" as const,
    fontSize: "12px",
    flexShrink: 0,
  },
  catCardInfoRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "6px",
    gap: "12px",
  },
  catCardInfoLabel: {
    color: "#666666",
    fontSize: "14px",
    fontWeight: 500,
  },
  catCardInfoValue: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#1A1A1A",
    textAlign: "right" as const,
    maxWidth: "65%",
  },
  catCardButtonsRow: {
    display: "flex",
    flexDirection: "column" as const,
    gap: "8px",
    marginTop: "14px",
  },
  catCardButton: {
    width: "100%",
    borderRadius: "10px",
    padding: "11px 16px",
    fontWeight: "bold" as const,
    fontSize: "14px",
    textTransform: "none" as const,
    boxShadow: "none",
  },
  catCardNoMemberText: {
    color: "#888888",
    fontStyle: "italic" as const,
    fontSize: "14px",
    margin: "4px 0 12px 0",
  },
}));

export const useGetGraphqlChamberIdVariableObjForRootAdmin = () => {
  const {
    state: { userType },
  } = useContext(UserTypeContext);

  const location = useLocation();
  const chamberIdInLocationState = useMemo(() => {
    if (userType === UserType.RootAdmin) {
      return (
        (location.state || { chamberId: undefined }) as {
          chamberId: string | undefined;
        }
      ).chamberId;
    }
    return undefined;
  }, [location?.state, userType]);

  return userType === UserType.RootAdmin
    ? { chamberId: chamberIdInLocationState }
    : {};
};

type CustomCategoryAdvertisingBannerActivationInfoReturnForTable = Omit<
  CategoryAdvertisingBannerActivationInfoReturn,
  "sentEmailNotificationOfUpcomingExpiry" | "chamberMemberHasAcceptedAgreement"
>;

type SingleTableAllCategoryAdvertisingBannersForChammberDataType =
  GetAllCategoryAdvertisingBannersForChamberQuery["getAllCategoryAdvertisingBannersForChamber"]["categoryAdvertisingBanners"][0] & {
    id: string;
    humanReadableCategoryName: string;
    logo: string;
    availability: "sold" | "unsold" | "soldAndResold";
    waitingForApproval: boolean;
  };

export type AllTableAllCategoryAdvertisingBannersForChammberDataType =
  SingleTableAllCategoryAdvertisingBannersForChammberDataType[];

export const getExpiryUtcMilliTimestampThatIsSpecifiedMonthsAfterSpecifiedAdvertisingStartDateUtcMilli =
  ({
    advertisingStartDateUtcMilli,
    months,
  }: {
    advertisingStartDateUtcMilli: number;
    months: number;
  }) => {
    // Extend dayjs with UTC plugin
    dayjs.extend(utc);

    // Convert Unix timestamp to a UTC dayjs object
    const date = dayjs.unix(advertisingStartDateUtcMilli / 1000).utc(); // Divide by 1000 to convert milliseconds to seconds

    // Add specified months, to the date
    // this is done because we can assume that the provided advertisingStartDateUtcMilli is at 00:00:00 of user's day in their local timezone, so to get expiry time we just get day after the specified months... adding 1 hour to ensure its on the exact day after specified months
    const futureDate = date.add(months, "month").add(1, "hour");

    // Convert the modified date back to Unix timestamp (in milliseconds)
    const convertedTimestamp = futureDate.valueOf();
    return convertedTimestamp;
  };

type Order = "asc" | "desc";

interface FullPageAllCategoryAdvertisingBannersForChammberTableProps {
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  order: Order;
  orderBy: string;
  headCells: HeadCell[];
}

function FullPageAllCategoryAdvertisingBannersForChammberTableHead(
  props: FullPageAllCategoryAdvertisingBannersForChammberTableProps
) {
  const { order, orderBy, onRequestSort, headCells } = props;
  const createSortHandler =
    (property: string) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => {
          // Skip empty header cells - they are merged into the category column
          const isSortable = headCell.sortable !== false;
          const isCategory = headCell.id === "humanReadableCategoryName";
          return (
            <TableCell
              style={{
                fontWeight: 700,
                fontSize: "16px",
          
                padding: "10px 13px",
                verticalAlign: "top",
                backgroundColor: "#ffffff",
                color: "#000",
                borderTop: `0.5px solid ${theme.palette.text.secondary}`,
                borderBottom: `0.5px solid ${theme.palette.text.secondary}`,
                cursor: isSortable ? "pointer" : "default",
                userSelect: "none",
              }}
              key={headCell.id}
              align={headCell.alignCenter ? "center" : "left"}
              sortDirection={orderBy === headCell.id ? order : false}
              onClick={isSortable ? createSortHandler(headCell.id) : undefined}
            >
              {headCell.label && (
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                  justifyContent: "center",
                  alignItems: "flex-start",
                }}>
                  <div style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "2px",
                    alignItems: "center",
                  }}>
                    <span style={{
                      fontWeight: 700,
                      fontSize: "16px",
                
                      color: "#000",
                      lineHeight: "21px",
                    }}>
                      {headCell.label}
                    </span>
                    {isSortable && (
                      <img
                        src={SortIcon}
                        alt="Sort"
                        style={{
                          width: "16px",
                          height: "16px",
                          display: "inline-block",
                        }}
                      />
                    )}
                  </div>
                  {headCell.description && (
                    <span style={{
                      fontWeight: 300,
                      fontSize: "12px",
                      fontFamily: "Montserrat, sans-serif",
                      color: "#000000",
                      lineHeight: "15px",
                    }}>
                      {headCell.description}
                    </span>
                  )}
                </div>
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

function formatYearMonthDuration(months: number): string {
  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;

  if (years === 0) {
    return `${months} Month${months !== 1 ? "s" : ""}`;
  } else if (remainingMonths === 0) {
    return `${years} Year${years !== 1 ? "s" : ""}`;
  } else {
    return `${years} Year${years !== 1 ? "s" : ""
      } and ${remainingMonths} Month${remainingMonths !== 1 ? "s" : ""}`;
  }
}


type FeeOptionsWithId = CategoryAdvertisingBannersFeeOptionsReturn & {
  id: string;
};

const getInternalIdOfAdvertisingOption = ({
  timeLengthInMonths,
  bannerFeeInDollars,
}: {
  timeLengthInMonths: number;
  bannerFeeInDollars: number;
}) => `${timeLengthInMonths}_${bannerFeeInDollars}`;

function AdvertisingFeesTable({
  selectedAdvertisingOptionId,
  updatedCategoryAdvertisingBannerFeeOptions,
  chamberInfo,
}: AdvertisingFeesTableProps) {
  const enumStrings = useEnumStrings();

  const { nonDuesRevenue, activationFee } = useMemo(() => {
    const selectedOption = updatedCategoryAdvertisingBannerFeeOptions?.find(
      (o) => o.id === selectedAdvertisingOptionId
    );

    const bannerFee = selectedOption?.bannerFeeInDollars || 0;
    const splitPercentage =
      chamberInfo?.chamberEngageSettings
        .categoryAdvertisingBannersActivationFeeCpaSplitPercentage ?? 1;

    const activationFee =
      Number((bannerFee * (splitPercentage / 100)).toFixed(0)) || 0;

    const nonDuesRevenue = bannerFee - activationFee;

    return { nonDuesRevenue, activationFee };
  }, [
    chamberInfo?.chamberEngageSettings
      .categoryAdvertisingBannersActivationFeeCpaSplitPercentage,
    selectedAdvertisingOptionId,
    updatedCategoryAdvertisingBannerFeeOptions,
  ]);

  return (
    <table
      style={{
        width: "100%",
        maxWidth: "400px",
        borderCollapse: "collapse",
        border: "1px solid #d0d0d0",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "white",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <thead>
        <tr>
          <th
            style={{
              padding: "8px",
              color: "#333",
              fontWeight: "bold",
              borderBottom: "1px solid #d0d0d0",
              borderRight: "1px solid #d0d0d0",
              fontSize: "17px",
              backgroundColor: "white",
            }}
          >
            {enumStrings.manageChamberEngage.nonDuesRevenue}
          </th>
          <th
            style={{
              padding: "8px",
              color: "#333",
              fontWeight: "bold",
              borderBottom: "1px solid #d0d0d0",
              fontSize: "17px",
              position: "relative",
              backgroundColor: "white",
            }}
          >
            {enumStrings.manageChamberEngage.activationFee}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            style={{
              padding: "8px",
              borderRight: "1px solid #d0d0d0",
              fontSize: "16px",
              backgroundColor: "white",
            }}
          >
            {selectedAdvertisingOptionId ? `$${nonDuesRevenue}` : "Select Term"}
          </td>
          <td
            style={{
              padding: "8px",
              fontSize: "16px",
              backgroundColor: "white",
            }}
          >
            {selectedAdvertisingOptionId ? `$${activationFee}` : "Select Term"}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

function SellResellModal({
  modalIsOpen,
  handleModalClose,
  categoryAdvertisingBanner,
  allChamberMemberData,
  sellModalType,
  activationInfo,
  reactivationInfo,
  openDropDownTable,
  onActionResult,
  onRequestReactivate,
  onRequestDeactivate,
}: {
  modalIsOpen: boolean;
  handleModalClose: () => void;
  categoryAdvertisingBanner: SingleTableAllCategoryAdvertisingBannersForChammberDataType;
  allChamberMemberData: GetAllChamberMembersQuery;
  sellModalType: SellModalTypeEnum;
  activationInfo?:
  | CustomCategoryAdvertisingBannerActivationInfoReturnForTable
  | undefined
  | null;
  reactivationInfo?:
  | CustomCategoryAdvertisingBannerActivationInfoReturnForTable
  | undefined
  | null;
  openDropDownTable: () => void;
  onActionResult?: (result: { message: string; variant: "success" | "error" }) => void;
  onRequestReactivate?: () => void;
  onRequestDeactivate?: () => void;
}) {
  const classes = useStyles();
  const enumStrings = useEnumStrings();
  const isMobile = useMediaQuery("(max-width: 600px)");

  const chamberInfo = useGetChamberFromUserIdInAuth() as
    | GetUser_RootAdminChamberAdminQuery["getUser"]["chamberInfo"]
    | undefined;

  const [affirmativeActionInProgress, setAffirmativeActionInProgress] =
    useState(false);

  const [dialogState, setDialogState] = useState<{ open: boolean; message: string; variant: "success" | "error" }>({ open: false, message: "", variant: "success" });

  const [showMemberCompanyError, setShowMemberCompanyError] = useState(false);
  const [showAdvertisingOptionError, setShowAdvertisingOptionError] =
    useState(false);

  const [selectedChamberMemberId, setSelectedChamberMemberId] = useState<
    string | null
  >(null);

  const handleSetSelectedChamberMemberId = useCallback((id: string) => {
    setShowMemberCompanyError(false);
    setSelectedChamberMemberId(id);
  }, []);

  const [advertisingStartDateChange, setAdvertisingStartDateChange] =
    useState(0);

  const handleAdvdertisingStartDateChange = useCallback((val) => {
    setShowAdvertisingOptionError(false);
    setAdvertisingStartDateChange(dayjs(val).startOf("day").valueOf());
  }, []);

  const [selectedAdvertisingOptionId, setSelectedAdvertisingOptionId] =
    useState<string | null>(null);

  const handleAdvertisingOptionSelect = useCallback(
    (id: string) => {
      setShowAdvertisingOptionError(false);

      // when reselling or viewing resell, user needs to see the start date as the currently active sell's expiry date
      if (sellModalType === SellModalTypeEnum.Sell) {
        setAdvertisingStartDateChange(0);
      }
      setSelectedAdvertisingOptionId(id);
    },
    [sellModalType]
  );

  const [
    updatedCategoryAdvertisingBannerFeeOptions,
    setUpdatedCategoryAdvertisingBannerFeeOptions,
  ] = useState<FeeOptionsWithId[] | null>(null);

  // attach id to each fee option to keep track of what is selected
  useEffect(() => {
    if (
      !chamberInfo?.chamberEngageSettings.categoryAdvertisingBannersFeeOptions
    ) {
      return;
    }

    const res = [];

    for (
      let i = 0;
      i <
      chamberInfo.chamberEngageSettings.categoryAdvertisingBannersFeeOptions
        .length;
      i += 1
    ) {
      const advertisingOption =
        chamberInfo.chamberEngageSettings.categoryAdvertisingBannersFeeOptions[
        i
        ];
      res.push({
        ...advertisingOption,
        id: getInternalIdOfAdvertisingOption({
          bannerFeeInDollars: advertisingOption.bannerFeeInDollars,
          timeLengthInMonths: advertisingOption.timeLengthInMonths,
        }), // assuming two options cant exist with the same timeLengthInMonths and bannerFeeInDollars
      });
    }

    setUpdatedCategoryAdvertisingBannerFeeOptions(res);
  }, [chamberInfo?.chamberEngageSettings.categoryAdvertisingBannersFeeOptions]);

  const [autoApproveBannerContent, setAutoApproveBannerContent] =
    useState(false);

  useEffect(() => {
    if (updatedCategoryAdvertisingBannerFeeOptions) {
      // fill form for a resell update
      if (sellModalType === SellModalTypeEnum.ViewResell && reactivationInfo) {
        const internalIdOfAdvertisingOption = getInternalIdOfAdvertisingOption({
          bannerFeeInDollars:
            reactivationInfo.bannerFeeOptionSetAtActivationTime
              .bannerFeeInDollars,
          timeLengthInMonths:
            reactivationInfo.bannerFeeOptionSetAtActivationTime
              .timeLengthInMonths,
        });

        // check if the advertising option that was selected at the time of sale is still available
        const advertisingOptionFound =
          updatedCategoryAdvertisingBannerFeeOptions.find(
            (option) => option.id === internalIdOfAdvertisingOption
          );

        if (advertisingOptionFound) {
          setSelectedAdvertisingOptionId(advertisingOptionFound.id);
          setAdvertisingStartDateChange(
            reactivationInfo.activationStartDateUtcMilli
          );
        }

        setSelectedChamberMemberId(reactivationInfo.chamberMemberId);
        setAutoApproveBannerContent(
          reactivationInfo.autoApproveBannerContentUpdate ?? false
        );
        return;
      }

      if (sellModalType === SellModalTypeEnum.Resell && activationInfo) {
        // Pre-fill with existing activation data for the confirmation modal
        const internalId = getInternalIdOfAdvertisingOption({
          bannerFeeInDollars: activationInfo.bannerFeeOptionSetAtActivationTime.bannerFeeInDollars,
          timeLengthInMonths: activationInfo.bannerFeeOptionSetAtActivationTime.timeLengthInMonths,
        });
        const matchingOption = updatedCategoryAdvertisingBannerFeeOptions?.find(
          (option) => option.id === internalId
        );
        setSelectedAdvertisingOptionId(matchingOption?.id || null);
        setAdvertisingStartDateChange(
          getExpiryUtcMilliTimestampThatIsSpecifiedMonthsAfterSpecifiedAdvertisingStartDateUtcMilli(
            {
              advertisingStartDateUtcMilli:
                activationInfo?.activationStartDateUtcMilli || 0,
              months:
                activationInfo.bannerFeeOptionSetAtActivationTime
                  .timeLengthInMonths,
            }
          )
        );
        setSelectedChamberMemberId(activationInfo.chamberMemberId);
        setAutoApproveBannerContent(activationInfo.autoApproveBannerContentUpdate ?? false);
        return;
      }

      // reset form for a new resell or sell
      setSelectedAdvertisingOptionId(null);
      setAdvertisingStartDateChange(0);
      setSelectedChamberMemberId(null);
    }
  }, [
    activationInfo,
    reactivationInfo,
    sellModalType,
    updatedCategoryAdvertisingBannerFeeOptions,
  ]);

  const [activateBannerForCategoryAdvertisingBanner] =
    useActivateBannerForCategoryAdvertisingBannerMutation();

  const [reactivateBannerForCategoryAdvertisingBanner] =
    useReactivateBannerForCategoryAdvertisingBannerMutation();

  const graphqlChamberIdVariableObjForRootAdmin =
    useGetGraphqlChamberIdVariableObjForRootAdmin();

  const handleAffirmativeAction = useCallback(async () => {
    setAffirmativeActionInProgress(true);

    //validate data
    if (
      !(
        selectedChamberMemberId &&
        advertisingStartDateChange > 0 &&
        updatedCategoryAdvertisingBannerFeeOptions
      )
    ) {
      if (!selectedChamberMemberId) {
        setShowMemberCompanyError(true);
      }

      if (advertisingStartDateChange <= 0) {
        setShowAdvertisingOptionError(true);
      }

      setAffirmativeActionInProgress(false);
      return;
    }

    // execute sale
    const bannerFeeOptionSetAtActivationTime =
      updatedCategoryAdvertisingBannerFeeOptions.find(
        (option) => option.id === selectedAdvertisingOptionId
      );

    if (bannerFeeOptionSetAtActivationTime) {
      const bannerFeeOptionSetAtActivationTimeForMutation = omitDeep(
        bannerFeeOptionSetAtActivationTime,
        ["id", "__typename"]
      ) as CategoryAdvertisingBannersFeeOptionsInput;

      try {
        if (sellModalType === SellModalTypeEnum.Sell) {
          await activateBannerForCategoryAdvertisingBanner({
            variables: {
              ...graphqlChamberIdVariableObjForRootAdmin,
              categoryId: categoryAdvertisingBanner.categoryId,
              activationInfo: {
                activationStartDateUtcMilli: advertisingStartDateChange,
                bannerFeeOptionSetAtActivationTime:
                  bannerFeeOptionSetAtActivationTimeForMutation,
                chamberMemberId: selectedChamberMemberId,
                autoApproveBannerContentUpdate: autoApproveBannerContent,
              },
            },
            refetchQueries: [
              {
                query: GetAllCategoryAdvertisingBannersForChamberDocument,
                variables: {
                  ...graphqlChamberIdVariableObjForRootAdmin,
                },
              },
            ],
            awaitRefetchQueries: true,
          });

          openDropDownTable();
          setDialogState({ open: true, message: enumStrings.manageChamberEngage.activatedSuccessfully, variant: "success" });
        }

        if (sellModalType === SellModalTypeEnum.Resell && activationInfo) {
          await reactivateBannerForCategoryAdvertisingBanner({
            variables: {
              ...graphqlChamberIdVariableObjForRootAdmin,
              categoryId: categoryAdvertisingBanner.categoryId,
              reactivationInfo: {
                bannerFeeOptionSetAtActivationTime:
                  bannerFeeOptionSetAtActivationTimeForMutation,
                chamberMemberId: selectedChamberMemberId,
                autoApproveBannerContentUpdate: autoApproveBannerContent,
              },
            },
            refetchQueries: [
              {
                query: GetAllCategoryAdvertisingBannersForChamberDocument,
                variables: {
                  ...graphqlChamberIdVariableObjForRootAdmin,
                },
              },
            ],
            awaitRefetchQueries: true,
          });

          setDialogState({ open: true, message: enumStrings.manageChamberEngage.modals.categoryBannerSuccessfullyActivated, variant: "success" });
        }

        handleModalClose();
      } catch (error) {
        console.error(error);
        if (sellModalType === SellModalTypeEnum.Resell) {
          setDialogState({ open: true, message: enumStrings.manageChamberEngage.modals.failedToReactivate, variant: "error" });
        } else {
          setDialogState({ open: true, message: enumStrings.manageChamberEngage.modals.failedToActivate, variant: "error" });
        }
        handleModalClose();
      } finally {
        setAffirmativeActionInProgress(false);
      }
    }
  }, [
    selectedChamberMemberId,
    advertisingStartDateChange,
    updatedCategoryAdvertisingBannerFeeOptions,
    selectedAdvertisingOptionId,
    sellModalType,
    activationInfo,
    handleModalClose,
    activateBannerForCategoryAdvertisingBanner,
    graphqlChamberIdVariableObjForRootAdmin,
    categoryAdvertisingBanner.categoryId,
    autoApproveBannerContent,
    openDropDownTable,
    enumStrings.manageChamberEngage.activatedSuccessfully,
    enumStrings.manageChamberEngage.modals.categoryBannerSuccessfullyActivated,
    enumStrings.manageChamberEngage.modals.failedToReactivate,
    enumStrings.manageChamberEngage.modals.failedToActivate,
    reactivateBannerForCategoryAdvertisingBanner,
  ]);

  const modalTitleForType = useMemo(() => {
    if (categoryAdvertisingBanner) {
      if (sellModalType === SellModalTypeEnum?.Sell) {
        return enumStrings.manageChamberEngage.modals.activateBanner.replace(
          "{{category}}",
          categoryAdvertisingBanner.humanReadableCategoryName
        );
      }

      if (sellModalType === SellModalTypeEnum.Resell) {
        return reactivationInfo
          ? enumStrings.manageChamberEngage.modals.viewReactivation.replace(
              "{{category}}",
              categoryAdvertisingBanner.humanReadableCategoryName
            )
          : enumStrings.manageChamberEngage.modals.resellBanner.replace(
              "{{category}}",
              categoryAdvertisingBanner.humanReadableCategoryName
            );
      }

      if (sellModalType === SellModalTypeEnum.ViewResell) {
        return enumStrings.manageChamberEngage.modals.viewReactivation.replace(
          "{{category}}",
          categoryAdvertisingBanner.humanReadableCategoryName
        );
      }
    }

    return "";
  }, [categoryAdvertisingBanner, sellModalType, enumStrings.manageChamberEngage.modals]);

  const modalDescriptionForType = useMemo(() => {
    if (categoryAdvertisingBanner) {
      if (sellModalType === SellModalTypeEnum.Sell) {
        return (
          <h3 style={{ textAlign: "left", margin: 0, whiteSpace: "pre-wrap" }}>
            {enumStrings.manageChamberEngage.fillInformation}
            <div style={{ height: 10 }} />
            {enumStrings.manageChamberEngage.emailWarning}
          </h3>
        );
      }

      if (sellModalType === SellModalTypeEnum.Resell && activationInfo) {
        return (
          <h3 style={{ textAlign: "left", margin: 0, whiteSpace: "pre-wrap" }}>
            {enumStrings.manageChamberEngage.selectCompany}{" "}
            <span style={{ fontWeight: "bold" }}>
              (
              {activationInfo.activationStartDateUtcMilli > 0
                ? getLocalTimestamp(
                  getExpiryUtcMilliTimestampThatIsSpecifiedMonthsAfterSpecifiedAdvertisingStartDateUtcMilli(
                    {
                      advertisingStartDateUtcMilli:
                        activationInfo.activationStartDateUtcMilli,
                      months:
                        activationInfo.bannerFeeOptionSetAtActivationTime
                          .timeLengthInMonths,
                    }
                  ),
                  true
                )
                : "not found"}
              )
            </span>
            <div style={{ height: 10 }} />
            {enumStrings.manageChamberEngage.sellModal.fillInfoForMember.title}
            <div style={{ height: 10 }} />
            {
              enumStrings.manageChamberEngage.sellModal.fillInfoForMember
                .notificationMessage
            }
          </h3>
        );
      }

      if (sellModalType === SellModalTypeEnum.ViewResell) {
        return (
          <h3 style={{ textAlign: "left", margin: 0, whiteSpace: "pre-wrap" }}>
            {enumStrings.manageChamberEngage.sellModal.viewResell.title}
            <div style={{ height: 10 }} />
            {
              enumStrings.manageChamberEngage.sellModal.viewResell
                .notificationMessage
            }
          </h3>
        );
      }
    }

    return "";
  }, [
    categoryAdvertisingBanner,
    sellModalType,
    activationInfo,
    enumStrings.manageChamberEngage.fillInformation,
    enumStrings.manageChamberEngage.emailWarning,
    enumStrings.manageChamberEngage.selectCompany,
    enumStrings.manageChamberEngage.sellModal.fillInfoForMember.title,
    enumStrings.manageChamberEngage.sellModal.fillInfoForMember
      .notificationMessage,
    enumStrings.manageChamberEngage.sellModal.viewResell.title,
    enumStrings.manageChamberEngage.sellModal.viewResell.notificationMessage,
  ]);

  const affirmativeButtonTextForModalType = useMemo(() => {
    if (sellModalType === SellModalTypeEnum.Sell) {
      return enumStrings.manageChamberEngage.active.toUpperCase();
    }

    if (sellModalType === SellModalTypeEnum.Resell) {
      return enumStrings.manageChamberEngage.reactivate.toUpperCase();
    }

    return "";
  }, [
    enumStrings.manageChamberEngage.active,
    enumStrings.manageChamberEngage.reactivate,
    sellModalType,
  ]);

  // Direct reactivation handler for the confirmation modal — matches main branch API call
  const handleReactivateConfirm = useCallback(async () => {
    if (!activationInfo) return;

    // Check if already reactivated before calling the API
    if (reactivationInfo) {
      handleModalClose();
      onActionResult?.({ message: enumStrings.manageChamberEngage.modals.alreadyReactivated, variant: "error" });
      return;
    }

    setAffirmativeActionInProgress(true);
    try {
      await reactivateBannerForCategoryAdvertisingBanner({
        variables: {
          ...graphqlChamberIdVariableObjForRootAdmin,
          categoryId: categoryAdvertisingBanner.categoryId,
          reactivationInfo: {
            bannerFeeOptionSetAtActivationTime: {
              timeLengthInMonths: activationInfo.bannerFeeOptionSetAtActivationTime.timeLengthInMonths,
              bannerFeeInDollars: activationInfo.bannerFeeOptionSetAtActivationTime.bannerFeeInDollars,
            },
            chamberMemberId: activationInfo.chamberMemberId,
            autoApproveBannerContentUpdate: activationInfo.autoApproveBannerContentUpdate ?? false,
          },
        },
        refetchQueries: [
          {
            query: GetAllCategoryAdvertisingBannersForChamberDocument,
            variables: {
              ...graphqlChamberIdVariableObjForRootAdmin,
            },
          },
        ],
        awaitRefetchQueries: true,
      });

      handleModalClose();
      onActionResult?.({ message: enumStrings.manageChamberEngage.modals.categoryBannerSuccessfullyActivated, variant: "success" });
    } catch (error: any) {
      console.error(error);
      handleModalClose();
      onActionResult?.({ message: enumStrings.manageChamberEngage.modals.failedToReactivate, variant: "error" });
    } finally {
      setAffirmativeActionInProgress(false);
    }
  }, [
    activationInfo,
    reactivationInfo,
    reactivateBannerForCategoryAdvertisingBanner,
    graphqlChamberIdVariableObjForRootAdmin,
    categoryAdvertisingBanner.categoryId,
    handleModalClose,
    onActionResult,
    enumStrings.manageChamberEngage.modals.alreadyReactivated,
    enumStrings.manageChamberEngage.modals.categoryBannerSuccessfullyActivated,
    enumStrings.manageChamberEngage.modals.failedToReactivate,
  ]);

  // Compute reactivation data for the Resell confirmation modal
  const reactivateModalData = useMemo(() => {
    if (sellModalType !== SellModalTypeEnum.Resell || !activationInfo) return null;

    const memberName = allChamberMemberData?.getAllChamberMembers?.find(
      (m) => m?.id === activationInfo.chamberMemberId
    )?.name || "";

    const categoryName = categoryAdvertisingBanner?.humanReadableCategoryName || "";

    const currentExpirationDateUtcMilli = getExpiryUtcMilliTimestampThatIsSpecifiedMonthsAfterSpecifiedAdvertisingStartDateUtcMilli({
      advertisingStartDateUtcMilli: activationInfo.activationStartDateUtcMilli,
      months: activationInfo.bannerFeeOptionSetAtActivationTime.timeLengthInMonths,
    });
    const currentExpirationDate = getLocalTimestamp(currentExpirationDateUtcMilli, true);

    const bannerFee = activationInfo.bannerFeeOptionSetAtActivationTime.bannerFeeInDollars;
    const splitPercentage = chamberInfo?.chamberEngageSettings?.categoryAdvertisingBannersActivationFeeCpaSplitPercentage ?? 1;
    const activationFeeAmount = Number((bannerFee * (splitPercentage / 100)).toFixed(0)) || 0;

    return { memberName, categoryName, currentExpirationDate, bannerFee, activationFeeAmount };
  }, [sellModalType, activationInfo, allChamberMemberData, categoryAdvertisingBanner, chamberInfo]);

  // Resell (Reactivate) confirmation modal
  if (sellModalType === SellModalTypeEnum.Resell && reactivateModalData) {
    return (
      <>
      <Modal className={classes.modal} open={modalIsOpen}>
        <div
          style={{
            backgroundColor: "#E6E6E6",
            borderRadius: isMobile ? "12px" : "20px",
            width: "700px",
            maxWidth: isMobile ? "calc(100% - 32px)" : "95vw",
            margin: isMobile ? "0 16px" : undefined,
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            outline: "none",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",

            padding: isMobile ? "16px" : "30px",
          }}
        >
          {/* Title */}
          <h2
            style={{
              fontWeight: 600,
              margin: 0,
              fontSize: isMobile ? "18px" : "25px",
              textAlign: "center",

              color: "#000",
              lineHeight: "110%",
              textTransform: "capitalize",
            }}
          >
            {enumStrings.manageChamberEngage.buttons.reactivate}
            <br />
            {reactivateModalData.memberName}
            <br />
            Category Advertising Banner
          </h2>

          {/* Content box */}
          <div
            style={{
              border: "1px solid #000000",
              borderRadius: isMobile ? "12px" : "16px",
              padding: isMobile ? "16px" : "30px",
              marginTop: isMobile ? "14px" : "20px",
              width: "100%",
              boxSizing: "border-box",
              backgroundColor: "#FFFFFF",
              overflowY: "auto",
            }}
          >
            <p style={{ margin: 0, lineHeight: isMobile ? "1.55" : "200%", fontSize: isMobile ? "14px" : "20px", color: "#000" }}>
              Are you sure you want to <strong>{enumStrings.manageChamberEngage.reactivate}</strong> {reactivateModalData.memberName}&apos;s {reactivateModalData.categoryName} Category Advertising Banner?
            </p>

            <ul style={{ margin: isMobile ? "12px 0" : "16px 0", paddingLeft: "20px", lineHeight: isMobile ? "1.55" : "200%", fontSize: isMobile ? "14px" : "20px", color: "#000" }}>
              <li>
                The {reactivateModalData.categoryName} Banner status will be reactivated effective <strong>{reactivateModalData.currentExpirationDate}</strong>.
              </li>
              <li>
                The banners will automatically deactivate 365 days after the current expiration date (<strong>{reactivateModalData.currentExpirationDate}</strong>).
              </li>
              <li>
                To support renewals, your chamber will receive an automatic email notification <strong>60 days</strong> before the expiration date.
              </li>
            </ul>

            <p style={{ margin: isMobile ? "12px 0 0 0" : "16px 0 0 0", lineHeight: isMobile ? "1.55" : "200%", fontSize: isMobile ? "14px" : "20px", color: "#000" }}>
              Your chamber is responsible for invoicing {reactivateModalData.memberName} the ${reactivateModalData.bannerFee} + tax for {reactivateModalData.categoryName} Category Advertising Banner Reactivation fee.
            </p>

            <p style={{ margin: isMobile ? "12px 0 0 0" : "16px 0 0 0", lineHeight: isMobile ? "1.55" : "200%", fontSize: isMobile ? "14px" : "20px", color: "#000", fontWeight: 700 }}>
              Your chamber will be invoiced separately for the ${reactivateModalData.activationFeeAmount} +tax Activation Fee.
            </p>
          </div>

          {/* Buttons */}
          <div className={classes.modalButtonRowInline}>
            <Button
              onClick={handleReactivateConfirm}
              variant="contained"
              disabled={affirmativeActionInProgress}
              className={classes.modalInlineButton}
              style={{
                backgroundColor: affirmativeActionInProgress ? "#ccc" : theme.palette.primary.main,
              }}
            >
              {affirmativeActionInProgress ? (
                <CircularProgress size={24} style={{ color: "white" }} />
              ) : (
                enumStrings.manageChamberEngage.buttons.reactivate
              )}
            </Button>
            <Button
              onClick={handleModalClose}
              variant="contained"
              disabled={affirmativeActionInProgress}
              className={classes.modalInlineButton}
              style={{
                backgroundColor: affirmativeActionInProgress ? "#999" : (theme.palette as any).delete.main,
              }}
            >
              {enumStrings.manageChamberEngage.modals.cancelButton}
            </Button>
          </div>
        </div>
      </Modal>
      <SuccessDialog
        open={dialogState.open}
        onClose={() => setDialogState(prev => ({ ...prev, open: false }))}
        message={dialogState.message}
        variant={dialogState.variant}
        autoDismissMs={20000}
      />
      </>
    );
  }

  // View-only layout: show banners in the same pattern as the perk pages
  if (sellModalType === SellModalTypeEnum.ViewResell) {
    const viewBanners: BannerInput[] = (activationInfo?.banner || []).map((b: any, i: number) => ({
      contentUrl: b?.contentUrl || "",
      imageLink: b?.imageLink || null,
      contentType: b?.contentType,
      position: typeof b?.position === "number" ? b.position : i,
      waitingForApprovalByChamberAdmin: b?.waitingForApprovalByChamberAdmin ?? false,
    }));
    const bannerApprovalRequired = !(activationInfo?.autoApproveBannerContentUpdate ?? false);
    const categoryName = categoryAdvertisingBanner?.humanReadableCategoryName || "";

    return (
      <>
        <Modal className={classes.modal} open={modalIsOpen}>
          <div className={classes.paper} style={{ backgroundColor: "#FFFFFF", maxHeight: "90vh", overflowY: "auto", alignItems: "stretch", textAlign: "left" }}>
            <IconButton
              className={classes.closeButton}
              onClick={handleModalClose}
            >
              <CloseIcon style={{ fontSize: "16px" }} />
            </IconButton>

            {/* Approval status header */}
            <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "8px", marginTop: "4px", marginBottom: "8px", paddingRight: "40px" }}>
              <span style={{ fontSize: "15px", fontWeight: 700, color: "#24272C" }}>
                Banner Approval Status:
              </span>
              <span style={{ fontSize: "15px", fontWeight: 700, color: bannerApprovalRequired ? "#2E7D32" : "#C62828", textTransform: "uppercase", letterSpacing: "0.3px" }}>
                {bannerApprovalRequired ? "Required" : "Not Required"}
              </span>
            </div>

            {/* Category banners title */}
            <h2 style={{ margin: "8px 0 6px 0", fontSize: "20px", fontWeight: 700, color: "#24272C" }}>
              {categoryName ? `${categoryName} Banners` : "Category Banners"}
            </h2>

            {/* Description + helper */}
            <p style={{ margin: "0 0 10px 0", fontSize: "14px", lineHeight: "1.5", color: "#24272C" }}>
              The uploaded images and video banners will be displayed in this category in the Chamber Perks App™
            </p>
            <p style={{ margin: "0 0 14px 0", fontSize: "14px", lineHeight: "1.5", color: "#24272C" }}>
              Upload up to 4 image or video banners to promote your company. For best quality, we recommend an aspect ratio of 16:9 with a minimum size of 1280 × 720.
            </p>

            {/* Reuse the shared BannerPicker in read-only mode */}
            <BannerPicker
              key={`view-${categoryAdvertisingBanner.categoryId}`}
              pickerType="categoryAdvertisingChamberAdmin"
              pickerLabel=""
              formikVal={viewBanners}
              formikSetFieldValue={() => {}}
              disabled={true}
              autoApproveBannerContentUpdate={activationInfo?.autoApproveBannerContentUpdate ?? false}
              chamberName={categoryName}
              noCard
            />

            {/* Close button at bottom */}
            <div style={{ display: "flex", justifyContent: "center", marginTop: "16px" }}>
              <Button
                variant="contained"
                onClick={handleModalClose}
                style={{
                  backgroundColor: "#ED1C24",
                  color: "#FFFFFF",
                  fontWeight: 700,
                  borderRadius: "20px",
                  padding: "10px 40px",
                  textTransform: "uppercase",
                  boxShadow: "none",
                }}
              >
                {enumStrings.manageChamberEngage.categoryAdvertisingBanners.close}
              </Button>
            </div>
          </div>
        </Modal>
        <SuccessDialog
          open={dialogState.open}
          onClose={() => setDialogState(prev => ({ ...prev, open: false }))}
          message={dialogState.message}
          variant={dialogState.variant}
          autoDismissMs={5000}
        />
      </>
    );
  }

  // Sell and Resell form.
  return (
    <>
    <Modal className={classes.modal} open={modalIsOpen}>
      <div className={classes.paper}>
        <IconButton
          className={classes.closeButton}
          onClick={handleModalClose}
          disabled={affirmativeActionInProgress}
        >
          <CloseIcon style={{ fontSize: "16px" }} />
        </IconButton>
        <h2 className={classes.modalTitle}>{modalTitleForType}</h2>
        <div className={classes.modalContentBox}>
          {modalDescriptionForType && (
            <div className={classes.modalBodyText} style={{ marginBottom: "20px" }}>
              {modalDescriptionForType}
            </div>
          )}
          <div style={{ height: 35 }} />
          <ChamberMemberSelector
            allChamberMemberData={allChamberMemberData}
            chamberMemberId={selectedChamberMemberId}
            setChamberMemberId={handleSetSelectedChamberMemberId}
            isFilledVariant
          />
          {showMemberCompanyError && (
            <h3
              style={{
                margin: 0,
                marginTop: theme.spacing(1),
                color: "red",
              }}
            >
              {enumStrings.manageChamberEngage.selectMemberCompany}
            </h3>
          )}
          <div style={{ height: 35 }} />
          <h1 style={{ marginBottom: "0px", marginTop: "0px" }}>
            {enumStrings.manageChamberEngage.advertisingTerm}
          </h1>
          {showAdvertisingOptionError && (
            <h3
              style={{
                margin: 0,
                marginTop: theme.spacing(1),
                color: "red",
              }}
            >
              {enumStrings.manageChamberEngage.selectAdvertisingOption}
            </h3>
          )}
          <div style={{ height: 15 }} />
          {/* loop through default chamber engage settings herrr */}
          <div
            style={{
              width: "100%",
              maxWidth: 250,
            }}
          >
            {(updatedCategoryAdvertisingBannerFeeOptions || []).map(
              (advertisingOption, index) => {
                const optionIsChecked =
                  selectedAdvertisingOptionId === advertisingOption.id;

                return (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        marginTop: index === 0 ? 0 : 20,
                      }}
                      key={advertisingOption.id}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Radio
                          className={classes.radio}
                          onClick={() => {
                            handleAdvertisingOptionSelect(advertisingOption.id);
                          }}
                          checked={optionIsChecked}
                          style={{
                            cursor: "pointer",
                          }}
                        />
                        <h3 style={{ whiteSpace: "nowrap", margin: 0 }}>
                          {formatYearMonthDuration(
                            advertisingOption.timeLengthInMonths
                          )}
                        </h3>
                      </div>

                      <div style={{ width: 10 }} />
                      <Chip
                        label={
                          <h3
                            style={{
                              color: "white",
                              fontWeight: "bold",
                              margin: 0,
                              textAlign: "center",
                            }}
                          >
                            ${advertisingOption.bannerFeeInDollars}
                          </h3>
                        }
                        style={{
                          backgroundColor: theme.palette.primary.main,
                          borderColor: theme.palette.primary.main,
                          display: "flex",
                        }}
                      />
                    </div>
                    {optionIsChecked && (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        <div style={{ height: 5 }} />
                        <LocalizationProvider
                          key={`advertisingStartDate_${advertisingOption.id}`}
                          dateAdapter={AdapterDayjs}
                        >
                          <MobileDatePicker
                            slotProps={{
                              textField: {
                                disabled: false,
                                InputProps: {
                                  disableUnderline: true,
                                },
                                className: classes.filledDatePicker,
                                variant: "filled",
                                sx: {
                                  "& .MuiFilledInput-root:before": {
                                    borderBottom: "none",
                                  },
                                  "& .MuiFilledInput-root:after": {
                                    borderBottom: "none",
                                  },
                                  "& .MuiFilledInput-root:hover:before": {
                                    borderBottom: "none",
                                  },
                                  "& .MuiInputBase-input.MuiFilledInput-input.Mui-readOnly.MuiInputBase-readOnly":
                                  {
                                    cursor:
                                      sellModalType === SellModalTypeEnum.Sell
                                        ? "pointer"
                                        : "unset",
                                  },
                                },
                              },
                            }}
                            minDate={dayjs(Date.now())}
                            label={
                              sellModalType === SellModalTypeEnum.Sell
                                ? "Set Advertising Start Date"
                                : "Advertising Start Date"
                            }
                            format="ll"
                            onChange={handleAdvdertisingStartDateChange}
                            value={
                              advertisingStartDateChange > 0
                                ? dayjs(advertisingStartDateChange)
                                : undefined
                            }
                          />
                        </LocalizationProvider>
                        <div style={{ height: 10 }} />
                        <LocalizationProvider
                          key={`advertisingEndDate_${advertisingOption.id}`}
                          dateAdapter={AdapterDayjs}
                        >
                          <MobileDatePicker
                            slotProps={{
                              textField: {
                                disabled: true,
                                InputProps: {
                                  disableUnderline: true,
                                },
                                className: classes.filledDatePicker,
                                variant: "filled",
                                sx: {
                                  cursor: "not-allowed",
                                  "& .MuiFilledInput-root:before": {
                                    borderBottom: "none",
                                  },
                                  "& .MuiFilledInput-root:after": {
                                    borderBottom: "none",
                                  },
                                  "& .MuiFilledInput-root:hover:before": {
                                    borderBottom: "none",
                                  },
                                },
                              },
                            }}
                            label={"Advertising Expiry Date"}
                            format="ll"
                            value={
                              advertisingStartDateChange > 0
                                ? dayjs(
                                  getExpiryUtcMilliTimestampThatIsSpecifiedMonthsAfterSpecifiedAdvertisingStartDateUtcMilli(
                                    {
                                      advertisingStartDateUtcMilli:
                                        advertisingStartDateChange,
                                      months:
                                        advertisingOption.timeLengthInMonths,
                                    }
                                  )
                                )
                                : undefined
                            }
                          />
                        </LocalizationProvider>
                      </div>
                    )}
                  </div>
                );
              }
            )}
          </div>
          <div style={{ height: 40 }} />

          <AdvertisingFeesTable
            selectedAdvertisingOptionId={selectedAdvertisingOptionId}
            updatedCategoryAdvertisingBannerFeeOptions={
              updatedCategoryAdvertisingBannerFeeOptions
            }
            chamberInfo={chamberInfo}
          />

          <div style={{ height: 35 }} />
          <AutoApproveBannerContentToggle
            checked={!autoApproveBannerContent}
            onChange={(checked) => setAutoApproveBannerContent(!checked)}
          />
        </div>

        <div className={classes.modalButtonContainer}>
            <Button
              className={classes.yesButton}
              onClick={handleAffirmativeAction}
              variant="contained"
              disabled={affirmativeActionInProgress}
            >
              {affirmativeActionInProgress ? (
                <CircularProgress
                  size={30}
                  style={{
                    color: "white",
                  }}
                />
              ) : (
                affirmativeButtonTextForModalType
              )}
            </Button>
          <Button
            className={classes.okButton}
            onClick={handleModalClose}
            variant="contained"
            disabled={affirmativeActionInProgress}
          >
            {enumStrings.manageChamberEngage.categoryAdvertisingBanners.cancel}
          </Button>
        </div>
      </div>
    </Modal>
    <SuccessDialog
      open={dialogState.open}
      onClose={() => setDialogState(prev => ({ ...prev, open: false }))}
      message={dialogState.message}
      variant={dialogState.variant}
      autoDismissMs={20000}
    />
    </>
  );
}

type CategoryBannerMember = NonNullable<GetAllChamberMembersQuery["getAllChamberMembers"]>[number];

function IndividualMobileCard({
  categoryAdvertisingBanner,
  allChamberMemberData,
  allChamberMembersIdToName,
}: {
  categoryAdvertisingBanner: SingleTableAllCategoryAdvertisingBannersForChammberDataType;
  allChamberMemberData: GetAllChamberMembersQuery;
  allChamberMembersIdToName: { [key: string]: CategoryBannerMember };
}) {
  const classes = useStyles();
  const enumStrings = useEnumStrings();
  const history = useHistory();

  const [sellModalType, setSellModalType] = useState<SellModalTypeEnum>(SellModalTypeEnum.Sell);
  const [sellModalIsOpen, setSellModalIsOpen] = useState(false);
  const handleSellModalClose = useCallback(() => setSellModalIsOpen(false), []);
  const [sellModalActivationInfo, setSellModalActivationInfo] = useState<CustomCategoryAdvertisingBannerActivationInfoReturnForTable | undefined | null>(undefined);
  const [sellModalReactivationInfo, setSellModalReactivationInfo] = useState<CustomCategoryAdvertisingBannerActivationInfoReturnForTable | undefined | null>(undefined);

  const handleSellModalOpen = useCallback(({ sellModalType: type, activationInfo, reactivationInfo }: {
    sellModalType: SellModalTypeEnum;
    activationInfo?: CustomCategoryAdvertisingBannerActivationInfoReturnForTable | undefined | null;
    reactivationInfo?: CustomCategoryAdvertisingBannerActivationInfoReturnForTable | undefined | null;
  }) => {
    setSellModalActivationInfo(activationInfo);
    setSellModalReactivationInfo(reactivationInfo);
    setSellModalType(type);
    setSellModalIsOpen(true);
  }, []);

  const [deactivateModalOpen, setDeactivateModalOpen] = useState(false);
  const [deactivatingCategoryId, setDeactivatingCategoryId] = useState("");
  const [deactivatingChamberMemberId, setDeactivatingChamberMemberId] = useState("");
  const [deactivatingChamberMemberName, setDeactivatingChamberMemberName] = useState("");
  const [deactivateInProgress, setDeactivateInProgress] = useState(false);
  const [cardDialogState, setCardDialogState] = useState<{ open: boolean; message: string; variant: "success" | "error" }>({ open: false, message: "", variant: "success" });
  const [viewExpanded, setViewExpanded] = useState(false);

  const [deactivateBannerForCategoryAdvertisingBanner] = useDeactivateBannerForCategoryAdvertisingBannerMutation();
  const graphqlChamberIdVariableObjForRootAdmin = useGetGraphqlChamberIdVariableObjForRootAdmin();

  // Banner state for the inline View panel — mirrors IndividualTableRow's behavior
  const [bannerModalOpen, setBannerModalOpen] = useState(false);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const emptyBanner = { image: null as string | null, videoUrl: null as string | null, redirectUrl: null as string | null, waitingForApproval: false };
  const getMobileBannersData = useCallback(() => {
    const existingBanner = categoryAdvertisingBanner?.bannerSettings?.activationInfo?.banner;
    if (existingBanner && existingBanner.length > 0) {
      const mapped = existingBanner.map((b: any) => ({
        image: b?.contentType === BannerContentTypeEnum.Image ? b?.contentUrl || null : null,
        videoUrl: b?.contentType === BannerContentTypeEnum.Video ? b?.contentUrl || null : null,
        redirectUrl: b?.imageLink || null,
        waitingForApproval: b?.waitingForApprovalByChamberAdmin ?? false,
      }));
      while (mapped.length < 4) mapped.push({ ...emptyBanner });
      return mapped;
    }
    return [{ ...emptyBanner }, { ...emptyBanner }, { ...emptyBanner }, { ...emptyBanner }];
  }, [categoryAdvertisingBanner?.bannerSettings?.activationInfo?.banner]);
  const [mobileBannersData, setMobileBannersData] = useState(getMobileBannersData());
  useEffect(() => { setMobileBannersData(getMobileBannersData()); }, [getMobileBannersData]);
  const [updateBannerContentForCategoryAdvertisingBanner] = useUpdateBannerContentForCategoryAdvertisingBannerMutation();
  const [bannerUpdateInProgress, setBannerUpdateInProgress] = useState(false);

  const persistMobileBanners = useCallback(async (updatedBannersData: typeof mobileBannersData) => {
    setBannerUpdateInProgress(true);
    const bannerPayload: BannerInput[] = updatedBannersData
      .map((b, position) => {
        if (b.image) {
          return { contentType: BannerContentTypeEnum.Image, contentUrl: b.image, imageLink: b.redirectUrl || null, position, waitingForApprovalByChamberAdmin: b.waitingForApproval };
        }
        if (b.videoUrl) {
          return { contentType: BannerContentTypeEnum.Video, contentUrl: b.videoUrl, imageLink: null, position, waitingForApprovalByChamberAdmin: b.waitingForApproval };
        }
        return null;
      })
      .filter((b): b is NonNullable<typeof b> => b !== null);
    try {
      await updateBannerContentForCategoryAdvertisingBanner({
        variables: {
          ...graphqlChamberIdVariableObjForRootAdmin,
          categoryId: (categoryAdvertisingBanner?.categoryId || "") as any,
          banner: omitDeep(bannerPayload, ["__typename"]) as BannerInput[],
        },
        refetchQueries: [{ query: GetAllCategoryAdvertisingBannersForChamberDocument, variables: { ...graphqlChamberIdVariableObjForRootAdmin } }],
        awaitRefetchQueries: true,
      });
    } finally {
      setBannerUpdateInProgress(false);
    }
  }, [updateBannerContentForCategoryAdvertisingBanner, graphqlChamberIdVariableObjForRootAdmin, categoryAdvertisingBanner?.categoryId]);

  const handleOpenMobileBannerModal = (index: number) => {
    setCurrentBannerIndex(index);
    setBannerModalOpen(true);
  };
  const handleSaveMobileBanner = useCallback(async (data: { image: string | null; videoUrl: string | null; redirectUrl: string | null }) => {
    const newBannersData = [...mobileBannersData];
    newBannersData[currentBannerIndex - 1] = {
      ...data,
      waitingForApproval: mobileBannersData[currentBannerIndex - 1]?.waitingForApproval ?? false,
    };
    setMobileBannersData(newBannersData);
    setBannerModalOpen(false);
    await persistMobileBanners(newBannersData);
  }, [mobileBannersData, currentBannerIndex, persistMobileBanners]);

  const [deleteMobileBannerIndex, setDeleteMobileBannerIndex] = useState<number | null>(null);
  const handleMoveMobileBanner = useCallback(async (index: number, direction: "left" | "right") => {
    const newBannersData = [...mobileBannersData];
    const targetIndex = direction === "left" ? index - 1 : index + 1;
    if (targetIndex < 0 || targetIndex >= newBannersData.length) return;
    const temp = newBannersData[index];
    newBannersData[index] = newBannersData[targetIndex];
    newBannersData[targetIndex] = temp;
    setMobileBannersData(newBannersData);
    await persistMobileBanners(newBannersData);
  }, [mobileBannersData, persistMobileBanners]);
  const handleDeleteMobileBanner = useCallback(async (index: number) => {
    const newBannersData = [...mobileBannersData];
    newBannersData[index] = { image: null, videoUrl: null, redirectUrl: null, waitingForApproval: false };
    setMobileBannersData(newBannersData);
    setDeleteMobileBannerIndex(null);
    await persistMobileBanners(newBannersData);
  }, [mobileBannersData, persistMobileBanners]);
  const handleToggleMobileBannerApproval = useCallback(async (index: number) => {
    const newBannersData = [...mobileBannersData];
    if (!newBannersData[index]) return;
    newBannersData[index] = { ...newBannersData[index], waitingForApproval: !newBannersData[index].waitingForApproval };
    setMobileBannersData(newBannersData);
    await persistMobileBanners(newBannersData);
  }, [mobileBannersData, persistMobileBanners]);

  // Auto-approve chamber-level setting (mirrors IndividualTableRow)
  const [changeAutoApprovalForBannerContentOfCategoryAdvertisingBanner, { loading: mobileAutoApprovalLoading }] =
    useChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutation();
  const serverAutoApproveMobile = categoryAdvertisingBanner?.bannerSettings?.activationInfo?.autoApproveBannerContentUpdate ?? false;
  const [optimisticAutoApproveMobile, setOptimisticAutoApproveMobile] = useState<boolean | null>(null);
  useEffect(() => {
    if (optimisticAutoApproveMobile !== null && optimisticAutoApproveMobile === serverAutoApproveMobile) {
      setOptimisticAutoApproveMobile(null);
    }
  }, [optimisticAutoApproveMobile, serverAutoApproveMobile]);
  const effectiveAutoApproveMobile = optimisticAutoApproveMobile ?? serverAutoApproveMobile;
  const handleAutoApproveMobile = useCallback(async (newValue: boolean) => {
    setOptimisticAutoApproveMobile(newValue);
    try {
      await changeAutoApprovalForBannerContentOfCategoryAdvertisingBanner({
        variables: {
          ...graphqlChamberIdVariableObjForRootAdmin,
          categoryId: categoryAdvertisingBanner.categoryId as any,
          autoApproveBannerContentUpdate: newValue,
        },
        refetchQueries: [{ query: GetAllCategoryAdvertisingBannersForChamberDocument, variables: { ...graphqlChamberIdVariableObjForRootAdmin } }],
        awaitRefetchQueries: true,
      });
    } catch (e) {
      setOptimisticAutoApproveMobile(null);
      showActionErrorNotice(e);
    }
  }, [changeAutoApprovalForBannerContentOfCategoryAdvertisingBanner, graphqlChamberIdVariableObjForRootAdmin, categoryAdvertisingBanner.categoryId]);

  const handleDeactivate = useCallback(async () => {
    setDeactivateInProgress(true);
    await deactivateBannerForCategoryAdvertisingBanner({
      variables: {
        ...graphqlChamberIdVariableObjForRootAdmin,
        categoryId: deactivatingCategoryId as any,
        chamberMemberId: deactivatingChamberMemberId,
      },
      refetchQueries: ["getAllCategoryAdvertisingBannersForChamber"],
    });
    setDeactivateModalOpen(false);
    setDeactivateInProgress(false);
    setCardDialogState({ open: true, message: enumStrings.deactivatedSuccessfully, variant: "success" });
  }, [deactivateBannerForCategoryAdvertisingBanner, deactivatingCategoryId, deactivatingChamberMemberId, enumStrings.deactivatedSuccessfully, graphqlChamberIdVariableObjForRootAdmin]);

  const isSold = categoryAdvertisingBanner.availability === "sold" || categoryAdvertisingBanner.availability === "soldAndResold";
  const isResold = categoryAdvertisingBanner.availability === "soldAndResold";

  // Status label & color
  let statusText: string;
  let statusColor: string;
  if (categoryAdvertisingBanner.availability === "unsold") {
    statusText = enumStrings.manageChamberEngage.tableHeaders.availableStatus;
    statusColor = "#4CB230";
  } else if (isResold && categoryAdvertisingBanner.bannerSettings?.reactivationInfo) {
    const resoldDate = getLocalTimestamp(categoryAdvertisingBanner.bannerSettings.reactivationInfo.activationStartDateUtcMilli, true);
    statusText = `${enumStrings.manageChamberEngage.tableHeaders.resoldStatus} · ${resoldDate}`;
    statusColor = "#4CAF50";
  } else {
    statusText = enumStrings.manageChamberEngage.tableHeaders.soldStatus;
    statusColor = theme.palette.error.main;
  }

  // Member info
  const memberId = categoryAdvertisingBanner.bannerSettings?.activationInfo?.chamberMemberId || "";
  const memberRecord = allChamberMembersIdToName[memberId];
  const memberName = memberRecord?.name || "";
  const memberInitials = memberName.split(" ").filter(Boolean).map((w: string) => w[0] || "").join("").slice(0, 3).toUpperCase();

  // Fee, Term, Days
  let feeText: string | null = null;
  let termText: string | null = null;
  let daysText: string | null = null;
  let daysColor = "#4CAF50";

  if (isSold && categoryAdvertisingBanner.bannerSettings?.activationInfo) {
    const info = categoryAdvertisingBanner.bannerSettings.activationInfo;
    feeText = `$${info.bannerFeeOptionSetAtActivationTime.bannerFeeInDollars}/yr`;
    const infoToUse = categoryAdvertisingBanner.bannerSettings.reactivationInfo || info;
    const startMilli = infoToUse.activationStartDateUtcMilli;
    const months = infoToUse.bannerFeeOptionSetAtActivationTime.timeLengthInMonths;
    const endMilli = getExpiryUtcMilliTimestampThatIsSpecifiedMonthsAfterSpecifiedAdvertisingStartDateUtcMilli({ advertisingStartDateUtcMilli: startMilli, months });
    termText = `${getLocalTimestamp(startMilli, true)} → ${getLocalTimestamp(endMilli, true)}`;
    const totalDaysLeft = Math.max(0, Math.ceil((new Date(endMilli).getTime() - Date.now()) / (1000 * 60 * 60 * 24)));
    daysColor = totalDaysLeft <= 20 ? "#E53935" : "#4CAF50";
    daysText = enumStrings.manageChamberEngage.tableHeaders.daysLeft.replace("{{days}}", String(totalDaysLeft));
  }

  return (
    <div className={classes.mobileCardWrapper}>
      {sellModalIsOpen && (
        <SellResellModal
          modalIsOpen={sellModalIsOpen}
          handleModalClose={handleSellModalClose}
          categoryAdvertisingBanner={categoryAdvertisingBanner}
          allChamberMemberData={allChamberMemberData}
          sellModalType={sellModalType}
          activationInfo={sellModalActivationInfo}
          reactivationInfo={sellModalReactivationInfo}
          openDropDownTable={() => {}}
          onActionResult={({ message, variant }) => {
            setSellModalIsOpen(false);
            setCardDialogState({ open: true, message, variant });
          }}
          onRequestReactivate={() => {
            handleSellModalOpen({
              sellModalType: SellModalTypeEnum.Resell,
              activationInfo: categoryAdvertisingBanner.bannerSettings?.activationInfo,
              reactivationInfo: categoryAdvertisingBanner.bannerSettings?.reactivationInfo,
            });
          }}
          onRequestDeactivate={() => {
            setSellModalIsOpen(false);
            setDeactivatingCategoryId(categoryAdvertisingBanner.categoryId);
            setDeactivatingChamberMemberId(memberId);
            setDeactivatingChamberMemberName(memberName);
            setDeactivateModalOpen(true);
          }}
        />
      )}

      {deactivateModalOpen && (
        <Modal
          open={deactivateModalOpen}
          style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <div style={{ backgroundColor: "#E6E6E6", borderRadius: "20px", padding: "24px", maxWidth: "95vw", width: "600px", position: "relative" }}>
            <h2 style={{ textAlign: "center", fontWeight: 600, fontSize: "22px", color: "#000", margin: "0 0 20px 0" }}>
              {enumStrings.manageChamberEngage.categoryAdvertisingBanners.deactivateModalTitle}<br />
              {deactivatingChamberMemberName}<br />
              {enumStrings.manageChamberEngage.categoryAdvertisingBanners.categoryAdvertisingBanner}
            </h2>
            <div style={{ border: "1px solid #000", borderRadius: "12px", padding: "20px", marginBottom: "20px", backgroundColor: "#fff" }}>
              <p style={{ margin: 0 }}>
                {enumStrings.manageChamberEngage.categoryAdvertisingBanners.deactivateConfirmQuestion
                  .replace("{{memberName}}", deactivatingChamberMemberName)
                  .split("<bold>")
                  .map((part, i) => {
                    if (i === 0) return part;
                    const [bold, rest] = part.split("</bold>");
                    return <span key={i}><strong>{bold}</strong>{rest}</span>;
                  })}
              </p>
            </div>
            <div style={{ display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap" }}>
              <Button variant="contained" onClick={handleDeactivate} disabled={deactivateInProgress}
                style={{ backgroundColor: "#24272C", color: "white", borderRadius: "12px", padding: "12px 32px", fontWeight: 600, textTransform: "uppercase", boxShadow: "none" }}>
                {deactivateInProgress ? <CircularProgress size={20} style={{ color: "white" }} /> : enumStrings.manageChamberEngage.buttons.deactivate}
              </Button>
              <Button variant="contained" onClick={() => setDeactivateModalOpen(false)} disabled={deactivateInProgress}
                style={{ backgroundColor: (theme.palette as any).delete.main, color: "white", borderRadius: "12px", padding: "12px 32px", fontWeight: 600, textTransform: "uppercase", boxShadow: "none" }}>
                {enumStrings.manageChamberEngage.categoryAdvertisingBanners.cancel}
              </Button>
            </div>
          </div>
        </Modal>
      )}

      <div className={classes.categoryMobileCard}>
        {/* Category header */}
        <div className={classes.catCardHeader}>
          <LogoImage
            logoSource={categoryAdvertisingBanner.logo}
            size="small"
            squared
            chamberName={categoryAdvertisingBanner.humanReadableCategoryName}
          />
          <div style={{ fontWeight: 700, fontSize: "16px", color: "#1A1A1A", lineHeight: 1.2 }}>
            {categoryAdvertisingBanner.humanReadableCategoryName}
          </div>
        </div>

        {/* Status key:value */}
        <div className={classes.catCardInfoRow}>
          <span className={classes.catCardInfoLabel}>Status</span>
          <span style={{ fontWeight: 700, fontSize: "14px", color: statusColor }}>{statusText}</span>
        </div>

        {isSold ? (
          <>
            {/* Member row */}
            <div className={classes.catCardInfoRow}>
              <span className={classes.catCardInfoLabel}>Member</span>
              <span style={{ display: "flex", alignItems: "center", gap: "8px", maxWidth: "65%" }}>
                {memberRecord?.logo ? (
                  <img src={memberRecord.logo} alt={memberName} style={{ width: "24px", height: "24px", borderRadius: "6px", objectFit: "contain", flexShrink: 0 }} />
                ) : (
                  <div className={classes.catCardMemberAvatar} style={{ backgroundColor: "#E8F5E9", color: "#2E7D32" }}>
                    {memberInitials}
                  </div>
                )}
                <span style={{ fontWeight: 600, fontSize: "14px", color: "#1A1A1A", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{memberName}</span>
              </span>
            </div>

            {/* Info rows */}
            <div className={classes.catCardInfoRow}>
              <span className={classes.catCardInfoLabel}>{enumStrings.manageChamberEngage.fee}</span>
              <span className={classes.catCardInfoValue}>{feeText}</span>
            </div>
            <div className={classes.catCardInfoRow}>
              <span className={classes.catCardInfoLabel}>{enumStrings.manageChamberEngage.term}</span>
              <span className={classes.catCardInfoValue}>{termText}</span>
            </div>
            <div className={classes.catCardInfoRow}>
              <span className={classes.catCardInfoLabel}>{enumStrings.manageMemberProfile.daysRemaining}</span>
              <span style={{ fontWeight: 700, fontSize: "14px", color: daysColor }}>{daysText}</span>
            </div>

            {/* Buttons */}
            <div className={classes.catCardButtonsRow}>
              <Button
                variant="contained"
                className={classes.catCardButton}
                style={{ backgroundColor: theme.palette.primary.main, color: "white" }}
                onClick={() => handleSellModalOpen({
                  sellModalType: SellModalTypeEnum.Resell,
                  activationInfo: categoryAdvertisingBanner.bannerSettings?.activationInfo,
                  reactivationInfo: categoryAdvertisingBanner.bannerSettings?.reactivationInfo,
                })}
              >
                {enumStrings.manageChamberEngage.buttons.reactivate}
              </Button>
              <Button
                variant="contained"
                className={classes.catCardButton}
                style={{ backgroundColor: "#24272C", color: "white" }}
                onClick={() => {
                  setDeactivatingCategoryId(categoryAdvertisingBanner.categoryId);
                  setDeactivatingChamberMemberId(memberId);
                  setDeactivatingChamberMemberName(memberName);
                  setDeactivateModalOpen(true);
                }}
              >
                {enumStrings.manageChamberEngage.buttons.deactivate}
              </Button>
              <Button
                variant="contained"
                className={classes.catCardButton}
                style={{ backgroundColor: viewExpanded ? (theme.palette as any).delete.main : theme.palette.primary.main, color: "white" }}
                onClick={() => setViewExpanded((v) => !v)}
              >
                {viewExpanded
                  ? enumStrings.manageChamberEngage.categoryAdvertisingBanners.close
                  : enumStrings.manageChamberEngage.categoryAdvertisingBanners.view}
              </Button>
            </div>

            {/* Inline expanded banner view — mirrors the web table's Collapse effect */}
            <Collapse in={viewExpanded} timeout="auto" unmountOnExit>
              {(() => {
                const approvalNotRequired = effectiveAutoApproveMobile;
                const categoryName = categoryAdvertisingBanner?.humanReadableCategoryName || "";
                return (
                  <div className={classes.formSection} style={{ marginTop: "24px" }}>
                    <div className={classes.sectionHeader}>
                      <p className={classes.sectionTitle}>
                        {enumStrings.manageChamberEngage.categoryAdvertisingBanners.advertisingBannersTitle.replace("{{categoryName}}", categoryName)}
                      </p>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "8px", marginBottom: "12px", flexWrap: "wrap" }}>
                      <span style={{ fontFamily: "DM Sans", fontWeight: 600, fontSize: "14px", color: "#24272C" }}>
                        {enumStrings.manageChamberEngage.categoryAdvertisingBanners.bannerApprovalStatus}
                      </span>
                      <span style={{ fontFamily: "DM Sans", fontWeight: 700, fontSize: "14px", color: approvalNotRequired ? theme.palette.success.main : (theme.palette as any).delete.main }}>
                        {approvalNotRequired
                          ? enumStrings.manageChamberEngage.categoryAdvertisingBanners.bannerApprovalNotRequired
                          : enumStrings.manageChamberEngage.categoryAdvertisingBanners.bannerApprovalNotApproved}
                      </span>
                    </div>
                    <p style={{ fontSize: "14px", lineHeight: "20px", fontWeight: 400, color: "#000000", marginBottom: "8px", textAlign: "left" }}>
                      {enumStrings.manageChamberEngage.categoryAdvertisingBanners.bannerDescription}
                    </p>
                    <p style={{ fontSize: "14px", lineHeight: "20px", fontWeight: 400, color: "#000000", marginBottom: "16px", textAlign: "left" }}>
                      {enumStrings.manageChamberEngage.categoryAdvertisingBanners.bannerUploadInstructions}
                      {" "}
                      {enumStrings.manageChamberEngage.categoryAdvertisingBanners.bannerUploadQuality.split("<bold>").map((part, i) => {
                        if (i === 0) return part;
                        const [bold, rest] = part.split("</bold>");
                        return <span key={i}><strong>{bold}</strong>{rest}</span>;
                      })}
                    </p>
                    <div className={classes.bannerUploadRow}>
                      {mobileBannersData.map((banner, index) => {
                        const hasMedia = banner.image || banner.videoUrl;
                        const isApproved = hasMedia ? !banner.waitingForApproval : false;
                        const statusColor = isApproved ? theme.palette.success.main : (theme.palette as any).delete.main;
                        return (
                        <div
                          key={index}
                          style={{ display: "flex", flex: "1 1 0", minWidth: 0, flexDirection: "column", alignItems: "center", gap: "8px" }}
                        >
                          <p style={{ textAlign: "center", fontWeight: 600, color: theme.palette.primary.main, fontSize: "15px", lineHeight: "20px", margin: 0 }}>
                            {enumStrings.manageChamberEngage.categoryAdvertisingBanners.bannerLabel.replace("{{number}}", String(index + 1))}
                          </p>
                          {banner.image || banner.videoUrl ? (
                            <div
                              style={{
                                backgroundColor: "#FFFFFF",
                                border: `2px solid ${theme.palette.primary.main}`,
                                borderRadius: "10px",
                                overflow: "hidden",
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                                boxSizing: "border-box",
                              }}
                            >
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "8px", flex: 1, minHeight: "100px" }}>
                                {banner.image ? (
                                  <img src={banner.image} alt={`Banner ${index + 1}`} style={{ width: "100%", height: "100%", maxHeight: "100px", objectFit: "cover", borderRadius: "4px" }} />
                                ) : (
                                  <div style={{ width: "100%", height: "100px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: theme.palette.primary.main, fontSize: "13px", fontWeight: 600, gap: "4px", border: `1px solid ${theme.palette.primary.main}`, borderRadius: "4px", boxSizing: "border-box" }}>
                                    <img src={VideoIcon} alt="Video" style={{ width: "32px", height: "32px" }} />
                                    {enumStrings.editMemberForm?.watchVideo || "Watch Video"}
                                  </div>
                                )}
                              </div>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "6px 8px" }}>
                                <div style={{ display: "flex", gap: "4px" }}>
                                  <IconButton
                                    size="small"
                                    disabled={bannerUpdateInProgress}
                                    onClick={() => handleOpenMobileBannerModal(index + 1)}
                                    style={{ backgroundColor: "#E3E3E3", borderRadius: "5px", width: "30px", height: "28px", padding: "4px" }}
                                  >
                                    <img src={EditOrangeIcon} alt="Edit" style={{ width: "16px", height: "16px", filter: "brightness(0)" }} />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    disabled={bannerUpdateInProgress}
                                    onClick={() => setDeleteMobileBannerIndex(index)}
                                    style={{ backgroundColor: (theme.palette as any).delete.main, borderRadius: "5px", width: "30px", height: "28px", padding: "4px" }}
                                  >
                                    <img src={TrashIcon} alt="Delete" style={{ width: "16px", height: "18px", filter: "brightness(0) invert(1)" }} />
                                  </IconButton>
                                </div>
                                <div style={{ display: "flex", gap: "2px" }}>
                                  <IconButton
                                    size="small"
                                    onClick={() => handleMoveMobileBanner(index, "left")}
                                    disabled={index === 0 || bannerUpdateInProgress}
                                    style={{ backgroundColor: index === 0 ? "#D9D9D9" : theme.palette.primary.main, color: index === 0 ? "#666" : "white", borderRadius: "5px", minWidth: "26px", width: "26px", height: "22px", padding: "4px" }}
                                  >
                                    <ArrowBackIosIcon style={{ fontSize: "10px", marginLeft: "4px" }} />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    onClick={() => handleMoveMobileBanner(index, "right")}
                                    disabled={index === mobileBannersData.length - 1 || bannerUpdateInProgress}
                                    style={{ backgroundColor: index === mobileBannersData.length - 1 ? "#D9D9D9" : theme.palette.primary.main, color: index === mobileBannersData.length - 1 ? "#666" : "white", borderRadius: "5px", minWidth: "26px", width: "26px", height: "22px", padding: "4px" }}
                                  >
                                    <ArrowForwardIosIcon style={{ fontSize: "10px" }} />
                                  </IconButton>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div
                              onClick={() => !bannerUpdateInProgress && handleOpenMobileBannerModal(index + 1)}
                              style={{
                                backgroundColor: "#FFFFFF",
                                border: `2px solid ${theme.palette.primary.main}`,
                                borderRadius: "10px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                                height: "90px",
                                boxSizing: "border-box",
                                padding: "12px 8px",
                                gap: "6px",
                                cursor: bannerUpdateInProgress ? "wait" : "pointer",
                              }}
                            >
                              <img src={UploadRoundIcon} alt="Upload" style={{ width: "28px", height: "28px" }} />
                              <p style={{ color: theme.palette.primary.main, fontSize: "12px", fontWeight: 600, margin: 0, lineHeight: 1.3, textAlign: "center" }}>
                                {enumStrings.manageChamberEngage.categoryAdvertisingBanners.uploadBanner}
                              </p>
                            </div>
                          )}
                          {hasMedia && (
                            <div
                              style={{ display: "flex", alignItems: "center", gap: "10px", cursor: bannerUpdateInProgress ? "wait" : "pointer", marginTop: "4px" }}
                              onClick={() => !bannerUpdateInProgress && handleToggleMobileBannerApproval(index)}
                            >
                              <span style={{ fontWeight: 600, fontSize: "13px", lineHeight: "18px", color: statusColor }}>
                                {isApproved
                                  ? enumStrings.manageChamberEngage.categoryAdvertisingBanners.approvedStatus
                                  : enumStrings.manageChamberEngage.categoryAdvertisingBanners.notApprovedStatus}
                              </span>
                              <div style={{ width: "32px", height: "16px", borderRadius: "8px", backgroundColor: isApproved ? "rgba(0, 182, 33, 0.13)" : "rgba(237, 28, 36, 0.13)", border: `0.5px solid ${statusColor}`, position: "relative", display: "flex", alignItems: "center" }}>
                                <div style={{ width: "12px", height: "12px", borderRadius: "50%", backgroundColor: statusColor, position: "absolute", left: isApproved ? "17px" : "3px", transition: "left 0.3s ease", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  {isApproved ? (
                                    <svg width="7" height="7" viewBox="0 0 24 24" fill="white"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
                                  ) : (
                                    <svg width="7" height="2" viewBox="0 0 8 2" fill="white"><rect width="8" height="2" rx="1" /></svg>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        );
                      })}
                    </div>
                    {bannerUpdateInProgress && (
                      <div style={{ display: "flex", justifyContent: "center", marginTop: "12px" }}>
                        <CircularProgress size={20} style={{ color: theme.palette.primary.main }} />
                      </div>
                    )}

                    {/* Chamber-level auto-approve toggle — same component the web uses */}
                    <AutoApproveBannerContentToggle
                      checked={!effectiveAutoApproveMobile}
                      onChange={(checked) => handleAutoApproveMobile(!checked)}
                      disabled={mobileAutoApprovalLoading}
                    />
                  </div>
                );
              })()}
            </Collapse>

            {/* Banner Upload/Edit Modal for mobile inline view */}
            {bannerModalOpen && (
              <BannerUploadModal
                open={bannerModalOpen}
                onClose={() => setBannerModalOpen(false)}
                bannerIndex={currentBannerIndex}
                initialData={mobileBannersData[currentBannerIndex - 1] || { image: null, videoUrl: null, redirectUrl: null }}
                onSave={handleSaveMobileBanner}
              />
            )}

            {/* Delete confirmation for mobile banner */}
            {deleteMobileBannerIndex !== null && (
              <DeleteBannerModal
                open={deleteMobileBannerIndex !== null}
                onClose={() => setDeleteMobileBannerIndex(null)}
                onDelete={() => handleDeleteMobileBanner(deleteMobileBannerIndex)}
              />
            )}
          </>
        ) : (
          <>
            <p className={classes.catCardNoMemberText}>{enumStrings.manageChamberEngage.noMemberPurchased}</p>
            <Button
              variant="contained"
              style={{ width: "100%", backgroundColor: theme.palette.primary.main, color: "white", borderRadius: "10px", padding: "14px 16px", fontWeight: "bold", fontSize: "15px", textTransform: "none", boxShadow: "none" }}
              onClick={() => history.push(RedirectUri.chamberEngageActivateCategoryBanners, { preSelectedCategoryId: categoryAdvertisingBanner.categoryId })}
            >
              {enumStrings.manageChamberEngage.activateForMember}
            </Button>
          </>
        )}
      </div>

      <SuccessDialog
        open={cardDialogState.open}
        onClose={() => setCardDialogState(prev => ({ ...prev, open: false }))}
        message={cardDialogState.message}
        variant={cardDialogState.variant}
        autoDismissMs={5000}
      />
    </div>
  );
}

function IndividualTableRow({
  index,
  humanReadableCategoryName,
  categoryAdvertisingBanner,
  allChamberMemberData,
  allChamberMembersIdToName,
}: {
  index: number;
  humanReadableCategoryName: string;
  categoryAdvertisingBanner: SingleTableAllCategoryAdvertisingBannersForChammberDataType;
  allChamberMemberData: GetAllChamberMembersQuery;
  allChamberMembersIdToName: { [key: string]: CategoryBannerMember };
}) {
  const classes = useStyles();
  const enumStrings = useEnumStrings();
  const history = useHistory();
  const [dropDownTableOpen, setDropDownTableOpen] = useState(false);
  const [rowDialogState, setRowDialogState] = useState<{ open: boolean; message: string; variant: "success" | "error" }>({ open: false, message: "", variant: "success" });

  const openDropDownTable = useCallback(() => {
    setDropDownTableOpen(true);
  }, []);

  const closeDropDownTable = useCallback(() => {
    setDropDownTableOpen(false);
  }, []);

  const toggleDropDownTable = useCallback(() => {
    if (dropDownTableOpen) {
      closeDropDownTable();
      return;
    }

    openDropDownTable();
  }, [closeDropDownTable, dropDownTableOpen, openDropDownTable]);

  const [sellModalType, setSellModalType] = useState<SellModalTypeEnum>(
    SellModalTypeEnum.Sell
  );

  const [sellModalIsOpen, setSellModalIsOpen] = useState(false);
  const handleSellModalClose = useCallback(() => {
    setSellModalIsOpen(false);
  }, []);

  const [sellModalActivationInfo, setSellModalActivationInfo] = useState<
    | CustomCategoryAdvertisingBannerActivationInfoReturnForTable
    | undefined
    | null
  >(undefined);
  const [sellModalReactivationInfo, setSellModalReactivationInfo] = useState<
    | CustomCategoryAdvertisingBannerActivationInfoReturnForTable
    | undefined
    | null
  >(undefined);

  const handleSellModalOpen = useCallback(
    ({
      sellModalType,
      activationInfo,
      reactivationInfo,
    }: {
      sellModalType: SellModalTypeEnum;
      activationInfo?:
      | CustomCategoryAdvertisingBannerActivationInfoReturnForTable
      | undefined
      | null;
      reactivationInfo?:
      | CustomCategoryAdvertisingBannerActivationInfoReturnForTable
      | undefined
      | null;
    }) => {
      setSellModalActivationInfo(activationInfo);
      setSellModalReactivationInfo(reactivationInfo);
      setSellModalType(sellModalType);
      setSellModalIsOpen(true);
    },
    []
  );

  const [deactivateModalOpen, setDeactivateModalOpen] = useState(false);
  const [deactivatingCategoryId, setDeactivatingCategoryId] = useState("");
  const [deactivatingChamberMemberId, setDeactivatingChamberMemberId] =
    useState("");
  const [deactivatingChamberMemberName, setDeactivatingChamberMemberName] =
    useState("");
  const [deactivateInProgress, setDeactivateInProgress] = useState(false);

  const [deactivateBannerForCategoryAdvertisingBanner] =
    useDeactivateBannerForCategoryAdvertisingBannerMutation();

  const dropDownTableRow = useMemo(() => {
    if (categoryAdvertisingBanner?.bannerSettings) {
      const bannerSettings = categoryAdvertisingBanner.bannerSettings;
      return (
        <TableRow
          key={`${categoryAdvertisingBanner.id}_dropDownTableRow`}
          style={{
            backgroundColor: "#FFFFFF",
            height: "91px",
          }}
        >
          {/* Member Company */}
          <TableCell
            style={{
              fontSize: "14px",
        
              fontWeight: 400,
              color: "#000000",
              padding: "16px",
              textAlign: "left",
              borderTop: `0.5px solid ${theme.palette.text.secondary}`,
              borderBottom: "none",
            }}
          >
            <span>
              {allChamberMembersIdToName[bannerSettings.activationInfo.chamberMemberId]?.name}
            </span>
          </TableCell>
          {/* Pricing */}
          <TableCell
            style={{
              fontSize: "14px",
        
              fontWeight: 400,
              textAlign: "left",
              padding: "16px",
              color: "#000000",
              borderTop: `0.5px solid ${theme.palette.text.secondary}`,
              borderBottom: "none",
            }}
          >
            ${bannerSettings.activationInfo.bannerFeeOptionSetAtActivationTime.bannerFeeInDollars}
          </TableCell>
          {/* Start Date */}
          <TableCell
            style={{
              fontSize: "14px",
        
              fontWeight: 400,
              textAlign: "left",
              padding: "16px",
              color: "#000000",
              borderTop: `0.5px solid ${theme.palette.text.secondary}`,
              borderBottom: "none",
            }}
          >
            <span>
              {getLocalTimestamp(
                bannerSettings.activationInfo.activationStartDateUtcMilli,
                true
              )}
            </span>
          </TableCell>
          {/* End Date */}
          <TableCell
            style={{
              fontSize: "14px",
        
              fontWeight: 400,
              textAlign: "left",
              padding: "16px",
              color: "#000000",
              borderTop: `0.5px solid ${theme.palette.text.secondary}`,
              borderBottom: "none",
            }}
          >
            {(() => {
              const infoToUse = bannerSettings.reactivationInfo || bannerSettings.activationInfo;
              const startDateUtcMilli = infoToUse.activationStartDateUtcMilli;
              const months = infoToUse.bannerFeeOptionSetAtActivationTime.timeLengthInMonths;
              const expiryDateUtcMilli = getExpiryUtcMilliTimestampThatIsSpecifiedMonthsAfterSpecifiedAdvertisingStartDateUtcMilli({
                advertisingStartDateUtcMilli: startDateUtcMilli,
                months: months,
              });
              const currentDateUtcMilli = Date.now();
              const activeDays = Math.max(0, Math.ceil((currentDateUtcMilli - startDateUtcMilli) / (1000 * 60 * 60 * 24)));

              return (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "4px" }}>
                  <span>{getLocalTimestamp(expiryDateUtcMilli, true)}</span>
                  <span style={{ fontSize: "12px", color: theme.palette.success.main, fontWeight: 700, fontFamily: "Montserrat, sans-serif" }}>
                    {enumStrings.manageChamberEngage.tableHeaders.activeForDays.replace("{{days}}", String(activeDays))}
                  </span>
                </div>
              );
            })()}
          </TableCell>
          {/* Update Status */}
          <TableCell
            style={{
              fontSize: "14px",
        
              fontWeight: 400,
              textAlign: "left",
              padding: "16px",
              color: "#000000",
              borderTop: `0.5px solid ${theme.palette.text.secondary}`,
              borderBottom: "none",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: "9px", alignItems: "flex-start" }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: theme.palette.primary.main,
                  color: "white",
                  fontSize: "12px",
                  fontWeight: 500,
                  fontFamily: "Montserrat, sans-serif",
                  borderRadius: "22px",
                  padding: "8px 12px",
                  textTransform: "uppercase",
                  minWidth: "113px",
                  height: 31,
                  boxShadow: "none",
                  lineHeight: "15px",
                  whiteSpace: "nowrap",
                }}
                onClick={() => {
                  handleSellModalOpen({
                    sellModalType: SellModalTypeEnum.Resell,
                    activationInfo: bannerSettings.activationInfo,
                    reactivationInfo: bannerSettings.reactivationInfo,
                  });
                }}
              >
                {enumStrings.manageChamberEngage.buttons.reactivate}
              </Button>
            </div>
          </TableCell>
        </TableRow>
      );
    }

    return null;
  }, [
    categoryAdvertisingBanner.bannerSettings,
    categoryAdvertisingBanner.id,
    allChamberMembersIdToName,
    handleSellModalOpen,
  ]);

  const [
    parentOverrideForceMediaUploadModalClosed,
    setParentOverrideForceMediaUploadModalClosed,
  ] = useState(false);

  const [bannerUpdateInProgress, setBannerUpdateInProgress] = useState(false);

  // Banner modal state for new banner grid UI
  const [bannerModalOpen, setBannerModalOpen] = useState(false);
  const [bannerPreviewOpen, setBannerPreviewOpen] = useState(false);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const [deleteBannerIndex, setDeleteBannerIndex] = useState<number | null>(null);

  // Get initial banner data from existing banner settings - always returns 4 slots
  const emptyBanner = { image: null, videoUrl: null, redirectUrl: null, waitingForApproval: false };
  const getBannersData = () => {
    const existingBanner = categoryAdvertisingBanner?.bannerSettings?.activationInfo?.banner;
    if (existingBanner && existingBanner.length > 0) {
      const mapped = existingBanner.map(b => ({
        image: b?.contentType === BannerContentTypeEnum.Image ? b?.contentUrl || null : null,
        videoUrl: b?.contentType === BannerContentTypeEnum.Video ? b?.contentUrl || null : null,
        redirectUrl: b?.imageLink || null,
        waitingForApproval: b?.waitingForApprovalByChamberAdmin ?? false,
      }));
      // Always pad to 4 slots
      while (mapped.length < 4) {
        mapped.push({ ...emptyBanner });
      }
      return mapped;
    }
    return [
      { ...emptyBanner },
      { ...emptyBanner },
      { ...emptyBanner },
      { ...emptyBanner },
    ];
  };

  const [bannersData, setBannersData] = useState(getBannersData());
  const skipNextSyncRef = React.useRef(false);

  // Sync bannersData when GraphQL data changes (e.g. after mutation refetch)
  useEffect(() => {
    if (skipNextSyncRef.current) {
      skipNextSyncRef.current = false;
      return;
    }
    setBannersData(getBannersData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryAdvertisingBanner?.bannerSettings?.activationInfo?.banner]);

  const handleOpenBannerModal = (index: number) => {
    setCurrentBannerIndex(index);
    setBannerModalOpen(true);
  };

  const graphqlChamberIdVariableObjForRootAdmin =
    useGetGraphqlChamberIdVariableObjForRootAdmin();

  const [updateBannerContentForCategoryAdvertisingBanner] =
    useUpdateBannerContentForCategoryAdvertisingBannerMutation();

  const handleBannerUpdate = useCallback(
    async (updatedBanner: BannerInput[]) => {
      setBannerUpdateInProgress(true);

      await updateBannerContentForCategoryAdvertisingBanner({
        variables: {
          ...graphqlChamberIdVariableObjForRootAdmin,
          categoryId: categoryAdvertisingBanner?.categoryId || "",
          banner: omitDeep(updatedBanner, ["__typename"]) as BannerInput[],
        },
        refetchQueries: [
          {
            query: GetAllCategoryAdvertisingBannersForChamberDocument,
            variables: {
              ...graphqlChamberIdVariableObjForRootAdmin,
            },
          },
        ],
        awaitRefetchQueries: true,
      });

      setBannerUpdateInProgress(false);
      setParentOverrideForceMediaUploadModalClosed(true);

      setRowDialogState({ open: true, message: enumStrings.manageChamberEngage.updatedSuccessfully, variant: "success" });
    },
    [
      categoryAdvertisingBanner?.categoryId,
      enumStrings.manageChamberEngage.updatedSuccessfully,
      graphqlChamberIdVariableObjForRootAdmin,
      updateBannerContentForCategoryAdvertisingBanner,
    ]
  );

  const buildBannerPayload = (data: typeof bannersData): BannerInput[] =>
    data
      .filter(b => b.image || b.videoUrl)
      .map((b, position) => ({
        contentType: b.videoUrl ? BannerContentTypeEnum.Video : BannerContentTypeEnum.Image,
        contentUrl: (b.videoUrl || b.image) as string,
        imageLink: b.redirectUrl || undefined,
        position,
        waitingForApprovalByChamberAdmin: b.waitingForApproval,
      }));

  const handleSaveBanner = useCallback(async (data: { image: string | null; videoUrl: string | null; redirectUrl: string | null; }) => {
    const newBannersData = [...bannersData];
    newBannersData[currentBannerIndex - 1] = {
      ...data,
      waitingForApproval: bannersData[currentBannerIndex - 1]?.waitingForApproval ?? false,
    };
    setBannersData(newBannersData);
    setBannerModalOpen(false);
    await handleBannerUpdate(buildBannerPayload(newBannersData));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bannersData, currentBannerIndex, handleBannerUpdate]);

  const handleMoveBanner = async (index: number, direction: 'left' | 'right') => {
    const newBannersData = [...bannersData];
    const targetIndex = direction === 'left' ? index - 1 : index + 1;
    if (targetIndex >= 0 && targetIndex < newBannersData.length) {
      const temp = newBannersData[index];
      newBannersData[index] = newBannersData[targetIndex];
      newBannersData[targetIndex] = temp;
      setBannersData(newBannersData);
      await handleBannerUpdate(buildBannerPayload(newBannersData));
    }
  };

  const handleDeleteBanner = async (index: number) => {
    const newBannersData = [...bannersData];
    newBannersData[index] = { image: null, videoUrl: null, redirectUrl: null, waitingForApproval: false };
    setBannersData(newBannersData);
    await handleBannerUpdate(buildBannerPayload(newBannersData));
  };

  const activeBanners = bannersData.filter(b => b.image || b.videoUrl);

  const handleToggleBannerApproval = (bannerIndex: number) => {
    // Prevent useEffect from overwriting our optimistic update
    skipNextSyncRef.current = true;

    // Step 1: Immediately flip local UI state
    setBannersData(prev => {
      const updated = [...prev];
      if (updated[bannerIndex]) {
        updated[bannerIndex] = {
          ...updated[bannerIndex],
          waitingForApproval: !updated[bannerIndex].waitingForApproval,
        };
      }
      return updated;
    });

    // Step 2: Send mutation to server
    const existingBanners = categoryAdvertisingBanner?.bannerSettings?.activationInfo?.banner;
    if (!existingBanners) return;

    const updatedBanners: BannerInput[] = existingBanners.map((b, i) => ({
      contentUrl: b?.contentUrl || "",
      imageLink: b?.imageLink || undefined,
      contentType: b?.contentType || BannerContentTypeEnum.Image,
      position: b?.position ?? i,
      waitingForApprovalByChamberAdmin:
        i === bannerIndex
          ? !(b?.waitingForApprovalByChamberAdmin ?? false)
          : b?.waitingForApprovalByChamberAdmin ?? false,
    }));

    updateBannerContentForCategoryAdvertisingBanner({
      variables: {
        ...graphqlChamberIdVariableObjForRootAdmin,
        categoryId: categoryAdvertisingBanner?.categoryId || "",
        banner: omitDeep(updatedBanners, ["__typename"]) as BannerInput[],
      },
      refetchQueries: [
        {
          query: GetAllCategoryAdvertisingBannersForChamberDocument,
          variables: {
            ...graphqlChamberIdVariableObjForRootAdmin,
          },
        },
      ],
      awaitRefetchQueries: true,
    }).catch((error) => {
      console.error("Failed to toggle banner approval:", error);
      setBannersData(getBannersData());
      showActionErrorNotice(error);
    });
  };

  const [
    changeAutoApprovalForBannerContentOfCategoryAdvertisingBanner,
    {
      loading:
      changeAutoApprovalForBannerContentOfCategoryAdvertisingBannerLoading,
    },
  ] =
    useChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutation();

  const serverAutoApproveBannerContentUpdate =
    categoryAdvertisingBanner?.bannerSettings?.activationInfo?.autoApproveBannerContentUpdate ?? false;
  const [optimisticAutoApproveBannerContentUpdate, setOptimisticAutoApproveBannerContentUpdate] =
    useState<boolean | null>(null);
  useEffect(() => {
    if (
      optimisticAutoApproveBannerContentUpdate !== null &&
      optimisticAutoApproveBannerContentUpdate === serverAutoApproveBannerContentUpdate
    ) {
      setOptimisticAutoApproveBannerContentUpdate(null);
    }
  }, [optimisticAutoApproveBannerContentUpdate, serverAutoApproveBannerContentUpdate]);
  const effectiveAutoApproveBannerContentUpdate =
    optimisticAutoApproveBannerContentUpdate ?? serverAutoApproveBannerContentUpdate;

  const handleAutoApproveBannerContentUpdate = useCallback(
    async (autoApproveBannerContentUpdate: boolean) => {
      setOptimisticAutoApproveBannerContentUpdate(autoApproveBannerContentUpdate);
      try {
        await changeAutoApprovalForBannerContentOfCategoryAdvertisingBanner({
          variables: {
            ...graphqlChamberIdVariableObjForRootAdmin,
            categoryId: categoryAdvertisingBanner.categoryId,
            autoApproveBannerContentUpdate,
          },
          refetchQueries: [
            {
              query: GetAllCategoryAdvertisingBannersForChamberDocument,
              variables: {
                ...graphqlChamberIdVariableObjForRootAdmin,
              },
            },
          ],
          awaitRefetchQueries: true,
        });

        setRowDialogState({ open: true, message: `${enumStrings.manageChamberEngage.categoryAdvertisingBanners
            .autoApproval
          } ${autoApproveBannerContentUpdate
            ? enumStrings.manageChamberEngage.categoryAdvertisingBanners
              .enabled
            : enumStrings.manageChamberEngage.categoryAdvertisingBanners
              .disabled
          } ${enumStrings.manageChamberEngage.categoryAdvertisingBanners
            .successfully
          }`, variant: "success" });
      } catch (error) {
        setOptimisticAutoApproveBannerContentUpdate(null);
        setRowDialogState({ open: true, message: `${enumStrings.manageChamberEngage.categoryAdvertisingBanners.failedTo
          } ${autoApproveBannerContentUpdate
            ? enumStrings.manageChamberEngage.categoryAdvertisingBanners
              .enable
            : enumStrings.manageChamberEngage.categoryAdvertisingBanners
              .disable
          } ${enumStrings.manageChamberEngage.categoryAdvertisingBanners
            .autoApprovalTwo
          }`, variant: "error" });
        console.error(error);
      }
    },
    [
      categoryAdvertisingBanner.categoryId,
      changeAutoApprovalForBannerContentOfCategoryAdvertisingBanner,
      enumStrings.manageChamberEngage.categoryAdvertisingBanners.autoApproval,
      enumStrings.manageChamberEngage.categoryAdvertisingBanners
        .autoApprovalTwo,
      enumStrings.manageChamberEngage.categoryAdvertisingBanners.disable,
      enumStrings.manageChamberEngage.categoryAdvertisingBanners.disabled,
      enumStrings.manageChamberEngage.categoryAdvertisingBanners.enable,
      enumStrings.manageChamberEngage.categoryAdvertisingBanners.enabled,
      enumStrings.manageChamberEngage.categoryAdvertisingBanners.failedTo,
      enumStrings.manageChamberEngage.categoryAdvertisingBanners.successfully,
      graphqlChamberIdVariableObjForRootAdmin,
    ]
  );

  const handleDeactivate = useCallback(async () => {
    setDeactivateInProgress(true);
    try {
      await deactivateBannerForCategoryAdvertisingBanner({
        variables: {
          ...graphqlChamberIdVariableObjForRootAdmin,
          categoryId: deactivatingCategoryId as any,
          chamberMemberId: deactivatingChamberMemberId,
        },
        refetchQueries: [
          {
            query: GetAllCategoryAdvertisingBannersForChamberDocument,
            variables: {
              ...graphqlChamberIdVariableObjForRootAdmin,
            },
          },
        ],
        awaitRefetchQueries: true,
      });

      setRowDialogState({ open: true, message: enumStrings.manageChamberEngage.modals.successfullyDeactivated.replace("{{categoryName}}", humanReadableCategoryName).replace("{{memberName}}", deactivatingChamberMemberName), variant: "success" });
      setDeactivateModalOpen(false);
      setDeactivatingCategoryId("");
      setDeactivatingChamberMemberId("");
      setDeactivatingChamberMemberName("");
    } catch (error) {
      setRowDialogState({ open: true, message: enumStrings.manageChamberEngage.modals.failedToDeactivate, variant: "error" });
      console.error(error);
    } finally {
      setDeactivateInProgress(false);
    }
  }, [
    deactivateBannerForCategoryAdvertisingBanner,
    deactivatingCategoryId,
    deactivatingChamberMemberId,
    deactivatingChamberMemberName,
    humanReadableCategoryName,
    graphqlChamberIdVariableObjForRootAdmin,
    enumStrings.manageChamberEngage.modals.successfullyDeactivated,
    enumStrings.manageChamberEngage.modals.failedToDeactivate,
  ]);

  return (
    <>
      {sellModalIsOpen && (
        <SellResellModal
          key={`sellResellModal_${categoryAdvertisingBanner.categoryId}`}
          categoryAdvertisingBanner={categoryAdvertisingBanner}
          modalIsOpen={sellModalIsOpen}
          handleModalClose={handleSellModalClose}
          allChamberMemberData={allChamberMemberData}
          sellModalType={sellModalType}
          activationInfo={sellModalActivationInfo}
          reactivationInfo={sellModalReactivationInfo}
          openDropDownTable={openDropDownTable}
          onActionResult={(result) => setRowDialogState({ open: true, ...result })}
          onRequestReactivate={() => {
            handleSellModalOpen({
              sellModalType: SellModalTypeEnum.Resell,
              activationInfo: categoryAdvertisingBanner.bannerSettings?.activationInfo,
              reactivationInfo: categoryAdvertisingBanner.bannerSettings?.reactivationInfo,
            });
          }}
          onRequestDeactivate={() => {
            setSellModalIsOpen(false);
            const bannerSettings = categoryAdvertisingBanner.bannerSettings;
            const memberId = bannerSettings?.activationInfo?.chamberMemberId || "";
            const memberName = allChamberMembersIdToName[memberId]?.name || "";
            setDeactivatingCategoryId(categoryAdvertisingBanner.categoryId);
            setDeactivatingChamberMemberId(memberId);
            setDeactivatingChamberMemberName(memberName);
            setDeactivateModalOpen(true);
          }}
        />
      )}

      {deactivateModalOpen && (
        <Modal
          className={classes.modal}
          open={deactivateModalOpen}
          onClose={() => !deactivateInProgress && setDeactivateModalOpen(false)}
        >
          <div
            style={{
              backgroundColor: "#E6E6E6",
              borderRadius: "20px",
              width: "700px",
              maxWidth: "95vw",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              outline: "none",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
          
              padding: "30px",
            }}
          >
            {/* Title */}
            <h2
              style={{
                fontWeight: 600,
                margin: 0,
                fontSize: "25px",
                textAlign: "center",
          
                color: "#000",
                lineHeight: "110%",
                textTransform: "capitalize",
              }}
            >
              {enumStrings.manageChamberEngage.categoryAdvertisingBanners.deactivateModalTitle}
              <br />
              {deactivatingChamberMemberName}
              <br />
              {enumStrings.manageChamberEngage.categoryAdvertisingBanners.categoryAdvertisingBanner}
            </h2>

            {/* Content box */}
            <div
              style={{
                border: "1px solid #000000",
                borderRadius: "16px",
                padding: "30px",
                marginTop: "20px",
                width: "100%",
                boxSizing: "border-box",
                backgroundColor: "#FFFFFF",
                overflowY: "auto",
                maxHeight: "400px",
              }}
            >
              <p style={{ margin: 0, lineHeight: "200%", fontSize: "20px", color: "#000" }}>
                {enumStrings.manageChamberEngage.categoryAdvertisingBanners.deactivateConfirmQuestion
                  .replace("{{memberName}}", deactivatingChamberMemberName || "")
                  .split("<bold>").map((part, i) => {
                    if (i === 0) return part;
                    const [bold, rest] = part.split("</bold>");
                    return <span key={i}><strong>{bold}</strong>{rest}</span>;
                  })}
              </p>
              <p style={{ margin: "16px 0 0 0", lineHeight: "200%", fontSize: "20px", color: "#000" }}>
                {enumStrings.manageChamberEngage.categoryAdvertisingBanners.deactivateModalDescription
                  .replace("{{categoryName}}", humanReadableCategoryName)
                  .split("<bold>").map((part, i) => {
                    if (i === 0) return part;
                    const [bold, rest] = part.split("</bold>");
                    return <span key={i}><strong>{bold}</strong>{rest}</span>;
                  })}
              </p>
            </div>

            {/* Buttons */}
            <div className={classes.modalButtonRowInline}>
              <Button
                onClick={handleDeactivate}
                variant="contained"
                disabled={deactivateInProgress}
                className={classes.modalInlineButton}
                style={{
                  backgroundColor: deactivateInProgress ? "#ccc" : "#000000",
                }}
              >
                {deactivateInProgress ? (
                  <CircularProgress size={24} style={{ color: "white" }} />
                ) : (
                  enumStrings.manageChamberEngage.categoryAdvertisingBanners.deactivate
                )}
              </Button>
              <Button
                onClick={() => setDeactivateModalOpen(false)}
                variant="contained"
                disabled={deactivateInProgress}
                className={classes.modalInlineButton}
                style={{
                  backgroundColor: deactivateInProgress ? "#999" : (theme.palette as any).delete.main,
                }}
              >
                {enumStrings.manageChamberEngage.categoryAdvertisingBanners.cancel}
              </Button>
            </div>
          </div>
        </Modal>
      )}

      <TableRow
        hover
        role="checkbox"
        tabIndex={-1}
        key={categoryAdvertisingBanner.categoryId}
        style={{
          backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#F4F4F4",
          height: "91px",
        }}
        sx={{
          cursor: "unset",
        }}
      >
        {/* Directory Category */}
        <TableCell
          style={{
            fontSize: "16px",
            textAlign: "left",
            padding: "10px 12px",
      
            fontWeight: 500,
            color: "#000",
            borderBottom: "1px solid #E8E8E8",
            backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#F4F4F4",
          }}
          component="th"
          scope="row"
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <LogoImage
              logoSource={categoryAdvertisingBanner.logo}
              size="small"
              squared
              key={categoryAdvertisingBanner.humanReadableCategoryName}
              chamberName={categoryAdvertisingBanner.humanReadableCategoryName}
            />
            {categoryAdvertisingBanner.humanReadableCategoryName}
          </div>
        </TableCell>

        {/* Banner Status */}
        <TableCell
          style={{
            fontSize: "14px",
            textAlign: "left",
            padding: "10px 12px",

            fontWeight: 700,
            borderBottom: "1px solid #E8E8E8",
            backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#F4F4F4",
          }}
        >
          {categoryAdvertisingBanner.availability === "unsold" ? (
            <span style={{ color: "#4CB230" }}>{enumStrings.manageChamberEngage.tableHeaders.availableStatus}</span>
          ) : categoryAdvertisingBanner.availability === "soldAndResold" ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ color: "#4CAF50" }}>{enumStrings.manageChamberEngage.tableHeaders.resoldStatus}</span>
              {categoryAdvertisingBanner?.bannerSettings?.reactivationInfo && (
                <span style={{ fontSize: "14px", fontWeight: 600, color: "#000000" }}>
                  {enumStrings.manageChamberEngage.tableHeaders.resoldAsOf.replace(
                    "{{date}}",
                    getLocalTimestamp(
                      categoryAdvertisingBanner.bannerSettings.reactivationInfo.activationStartDateUtcMilli,
                      true
                    )
                  )}
                </span>
              )}
            </div>
          ) : (
            <span style={{ color: theme.palette.error.main }}>{enumStrings.manageChamberEngage.tableHeaders.soldStatus}</span>
          )}
        </TableCell>

        {/* Member Company */}
        <TableCell
          style={{
            fontSize: "14px",
            textAlign: "left",
            padding: "10px 12px",

            fontWeight: 500,
            color: "#000",
            borderBottom: "1px solid #E8E8E8",
            backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#F4F4F4",
          }}
        >
          {categoryAdvertisingBanner?.bannerSettings?.activationInfo ? (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {allChamberMembersIdToName[categoryAdvertisingBanner.bannerSettings.activationInfo.chamberMemberId]?.logo ? (
                <img
                  src={allChamberMembersIdToName[categoryAdvertisingBanner.bannerSettings.activationInfo.chamberMemberId].logo || undefined}
                  alt=""
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "6px",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "6px",
                    backgroundColor: "#E0E0E0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "16px",
                    fontWeight: 700,
                    color: "#666",
                  }}
                >
                  {(allChamberMembersIdToName[categoryAdvertisingBanner.bannerSettings.activationInfo.chamberMemberId]?.name || "?").charAt(0).toUpperCase()}
                </div>
              )}
              <span>
                {allChamberMembersIdToName[categoryAdvertisingBanner.bannerSettings.activationInfo.chamberMemberId]?.name || ""}
              </span>
            </div>
          ) : (
            <span style={{ color: "#999" }}>-</span>
          )}
        </TableCell>

        {/* Action */}
        <TableCell
          style={{
            fontSize: "14px",
            textAlign: "left",
            padding: "10px 12px",
            borderBottom: "1px solid #E8E8E8",
            backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#F4F4F4",
          }}
        >
          {categoryAdvertisingBanner?.bannerSettings ? (
            <div style={{ display: "flex", flexDirection: "column", gap: "9px", alignItems: "flex-start" }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: theme.palette.primary.main,
                  color: "white",
                  fontSize: "12px",
                  fontWeight: 500,
                  fontFamily: "Montserrat, sans-serif",
                  borderRadius: "22px",
                  padding: "8px 12px",
                  textTransform: "uppercase",
                  minWidth: "113px",
                  height: 31,
                  boxShadow: "none",
                  lineHeight: "15px",
                  whiteSpace: "nowrap",
                }}
                onClick={() => {
                  handleSellModalOpen({
                    sellModalType: SellModalTypeEnum.Resell,
                    activationInfo: categoryAdvertisingBanner.bannerSettings?.activationInfo,
                    reactivationInfo: categoryAdvertisingBanner.bannerSettings?.reactivationInfo,
                  });
                }}
              >
                {enumStrings.manageChamberEngage.buttons.reactivate}
              </Button>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#24272C",
                  color: "white",
                  fontSize: "12px",
                  fontWeight: 500,
                  fontFamily: "Montserrat, sans-serif",
                  borderRadius: "22px",
                  padding: "8px 12px",
                  textTransform: "uppercase",
                  minWidth: "113px",
                  height: 31,
                  boxShadow: "none",
                  lineHeight: "15px",
                  whiteSpace: "nowrap",
                }}
                onClick={() => {
                  setDeactivatingCategoryId(categoryAdvertisingBanner.categoryId);
                  setDeactivatingChamberMemberId(
                    categoryAdvertisingBanner.bannerSettings?.activationInfo?.chamberMemberId || ""
                  );
                  setDeactivatingChamberMemberName(
                    allChamberMembersIdToName[
                      categoryAdvertisingBanner.bannerSettings?.activationInfo?.chamberMemberId || ""
                    ]?.name || ""
                  );
                  setDeactivateModalOpen(true);
                }}
              >
                {enumStrings.manageChamberEngage.buttons.deactivate}
              </Button>
            </div>
          ) : (
            <Button
              variant="contained"
              style={{
                backgroundColor: theme.palette.primary.main,
                color: "white",
                fontSize: "12px",
                fontWeight: 500,
                fontFamily: "Montserrat, sans-serif",
                borderRadius: "22px",
                padding: "8px 12px",
                textTransform: "uppercase",
                minWidth: "113px",
                height: 31,
                boxShadow: "none",
                lineHeight: "15px",
                whiteSpace: "nowrap",
              }}
              onClick={() => {
                history.push(RedirectUri.chamberEngageActivateCategoryBanners, {
                  preSelectedCategoryId: categoryAdvertisingBanner.categoryId,
                });
              }}
            >
              {enumStrings.manageChamberEngage.buttons.activate}
            </Button>
          )}
        </TableCell>

        {/* Banners Fee */}
        <TableCell
          style={{
            fontSize: "14px",
            textAlign: "left",
            padding: "10px 12px",
            fontWeight: 500,
            color: "#000",
            borderBottom: "1px solid #E8E8E8",
            backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#F4F4F4",
          }}
        >
          {categoryAdvertisingBanner?.bannerSettings?.activationInfo ? (
            <span>${categoryAdvertisingBanner.bannerSettings.activationInfo.bannerFeeOptionSetAtActivationTime.bannerFeeInDollars}</span>
          ) : (
            <span style={{ color: "#999" }}>-</span>
          )}
        </TableCell>

        {/* Start Date */}
        <TableCell
          style={{
            fontSize: "14px",
            textAlign: "left",
            padding: "10px 12px",
            fontWeight: 500,
            color: "#000",
            borderBottom: "1px solid #E8E8E8",
            backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#F4F4F4",
          }}
        >
          {categoryAdvertisingBanner?.bannerSettings?.activationInfo ? (
            <span>
              {getLocalTimestamp(
                categoryAdvertisingBanner.bannerSettings.activationInfo.activationStartDateUtcMilli,
                true
              )}
            </span>
          ) : (
            <span style={{ color: "#999" }}>-</span>
          )}
        </TableCell>

        {/* End Date with days left */}
        <TableCell
          style={{
            fontSize: "14px",
            textAlign: "left",
            padding: "10px 12px",
            fontWeight: 500,
            color: "#000",
            borderBottom: "1px solid #E8E8E8",
            backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#F4F4F4",
          }}
        >
          {categoryAdvertisingBanner?.bannerSettings?.activationInfo ? (
            (() => {
              const infoToUse = categoryAdvertisingBanner.bannerSettings?.reactivationInfo || categoryAdvertisingBanner.bannerSettings?.activationInfo;
              if (!infoToUse) return <span style={{ color: "#999" }}>-</span>;
              const startDateUtcMilli = infoToUse.activationStartDateUtcMilli;
              const months = infoToUse.bannerFeeOptionSetAtActivationTime.timeLengthInMonths;
              const expiryDateUtcMilli = getExpiryUtcMilliTimestampThatIsSpecifiedMonthsAfterSpecifiedAdvertisingStartDateUtcMilli({
                advertisingStartDateUtcMilli: startDateUtcMilli,
                months: months,
              });
              const now = new Date();
              const endDate = new Date(expiryDateUtcMilli);
              const totalDaysLeft = Math.max(0, Math.ceil((endDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)));

              return (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "4px" }}>
                  <span>{getLocalTimestamp(expiryDateUtcMilli, true)}</span>
                  <span style={{ fontSize: "12px", color: totalDaysLeft <= 20 ? "#E53935" : "#4CAF50", fontWeight: 700, fontFamily: "Montserrat, sans-serif" }}>
                    {enumStrings.manageChamberEngage.tableHeaders.daysLeft
                      .replace("{{days}}", String(totalDaysLeft))
                    }
                  </span>
                </div>
              );
            })()
          ) : (
            <span style={{ color: "#999" }}>-</span>
          )}
        </TableCell>

        {/* View Banner Info */}
        <TableCell
          style={{
            fontSize: "14px",
            textAlign: "left",
            padding: "10px 12px",
            borderBottom: "1px solid #E8E8E8",
            backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#F4F4F4",
          }}
        >
          {categoryAdvertisingBanner?.bannerSettings ? (
            <Button
              type="submit"
              size="large"
              color="primary"
              variant="contained"
              style={{
                backgroundColor: dropDownTableOpen ? (theme.palette as any).delete.main : theme.palette.primary.main,
                fontSize: "12px",
                fontWeight: 500,
                fontFamily: "Montserrat, sans-serif",
                borderRadius: "22px",
                width: 110,
                height: 31,
                boxShadow: "none",
                textTransform: "uppercase",
              }}
              onClick={toggleDropDownTable}
            >
              {dropDownTableOpen ? enumStrings.manageChamberEngage.categoryAdvertisingBanners.close : enumStrings.manageChamberEngage.categoryAdvertisingBanners.view}
            </Button>
          ) : (
            <span style={{
              backgroundColor: "#24272C",
              color: "#FFFFFF",
              fontSize: "12px",
              fontWeight: 500,
              fontFamily: "Montserrat, sans-serif",
              borderRadius: "22px",
              width: 110,
              height: 31,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              textTransform: "uppercase",
              boxShadow: "none",
            }}>N/A</span>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
          <Collapse
            in={dropDownTableOpen}
            timeout="auto"
            unmountOnExit
            style={{
              backgroundColor: "#fafafa",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                background: "#FFFFFF",
                padding: "24px 32px",
              }}
            >




              {/* Dashed Border Container */}
              <div className={classes.formSection}>
                <div className={classes.sectionHeader}>
                  <p className={classes.sectionTitle}>{enumStrings.manageChamberEngage.categoryAdvertisingBanners.advertisingBannersTitle.replace("{{categoryName}}", humanReadableCategoryName)}</p>
                </div>
                {/* Banner Approval Status */}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "8px", marginBottom: "16px" }}>
                  <span style={{ fontFamily: "DM Sans", fontWeight: 600, fontSize: "18px", color: "#24272C" }}>
                    {enumStrings.manageChamberEngage.categoryAdvertisingBanners.bannerApprovalStatus}
                  </span>
                  {(() => {
                    const approvalNotRequired = effectiveAutoApproveBannerContentUpdate;
                    const hasWaitingBanners = bannersData.some(b => (b.image || b.videoUrl) && b.waitingForApproval);
                    const hasAnyBanners = bannersData.some(b => b.image || b.videoUrl);
                    const isApproved = hasAnyBanners && !hasWaitingBanners;
                    const statusLabel = approvalNotRequired
                      ? enumStrings.manageChamberEngage.categoryAdvertisingBanners.bannerApprovalNotRequired
                      : isApproved
                        ? enumStrings.manageChamberEngage.categoryAdvertisingBanners.bannerApprovalApproved
                        : enumStrings.manageChamberEngage.categoryAdvertisingBanners.bannerApprovalNotApproved;
                    const statusColor = approvalNotRequired || isApproved
                      ? theme.palette.success.main
                      : (theme.palette as any).delete.main;
                    return (
                      <span style={{
                        fontFamily: "DM Sans",
                        fontWeight: 700,
                        fontSize: "18px",
                        color: statusColor,
                      }}>
                        {statusLabel}
                      </span>
                    );
                  })()}
                </div>
                <p style={{

                  fontSize: "18px",
                  lineHeight: "24px",
                  fontWeight: 400,
                  color: "#000000",
                  marginBottom: "10px",
                  textAlign: "left",
                }}>
                  {enumStrings.manageChamberEngage.categoryAdvertisingBanners.bannerDescription}
                </p>
                <p style={{

                  fontSize: "18px",
                  lineHeight: "24px",
                  fontWeight: 400,
                  color: "#000000",
                  marginBottom: "20px",
                  textAlign: "left",
                }}>
                  {enumStrings.manageChamberEngage.categoryAdvertisingBanners.bannerUploadInstructions}
                  {" "}
                  {enumStrings.manageChamberEngage.categoryAdvertisingBanners.bannerUploadQuality.split("<bold>").map((part, i) => {
                    if (i === 0) return part;
                    const [bold, rest] = part.split("</bold>");
                    return <span key={i}><strong>{bold}</strong>{rest}</span>;
                  })}
                </p>
                {/* Banner Upload Grid - Same pattern as AddMemberBanners */}
                <div className={classes.bannerUploadRow}>
                  {bannersData.map((banner, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flex: "1 1 0",
                        minWidth: 0,
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <p
                        style={{
                          textAlign: "center",
                          fontWeight: 600,
                          color: theme.palette.primary.main,
                          fontSize: "20px",
                          lineHeight: "24px",
                          margin: 0,
                        }}
                      >
                        {enumStrings.manageChamberEngage.categoryAdvertisingBanners.bannerLabel.replace("{{number}}", String(index + 1))}
                      </p>
                      {banner.image || banner.videoUrl ? (
                        <div
                          style={{
                            backgroundColor: "#FFFFFF",
                            border: `2px solid ${theme.palette.primary.main}`,
                            borderRadius: "10px",
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            height: "175px",
                            boxSizing: "border-box",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              overflow: "hidden",
                              position: "relative",
                              padding: "12px",
                              flex: 1,
                            }}
                          >
                            {banner.image ? (
                              <img
                                src={banner.image}
                                alt={`Banner ${index + 1}`}
                                style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "4px" }}
                              />
                            ) : (
                              <div
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: theme.palette.primary.main,
                                  fontSize: "20px",
                                  fontWeight: 600,
                                  gap: "8px",
                                  border: `1px solid ${theme.palette.primary.main}`,
                                  borderRadius: "4px",
                                  boxSizing: "border-box",
                                }}
                              >
                                <img src={VideoIcon} alt="Video" style={{ width: "49px", height: "49px" }} />
                                {enumStrings.editMemberForm?.watchVideo || "Watch Video"}
                              </div>
                            )}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "6px 12px",
                            }}
                          >
                            <div style={{ display: "flex", gap: "8px" }}>
                              <IconButton
                                size="small"
                                onClick={() => handleOpenBannerModal(index + 1)}
                                style={{
                                  backgroundColor: "#E3E3E3",
                                  borderRadius: "5px",
                                  width: "36px",
                                  height: "33px",
                                  padding: "4px",
                                }}
                              >
                                <img src={EditOrangeIcon} alt="Edit" style={{ width: "20px", height: "20px", filter: "brightness(0)" }} />
                              </IconButton>
                              <IconButton
                                size="small"
                                onClick={() => setDeleteBannerIndex(index)}
                                style={{
                                  backgroundColor: (theme.palette as any).delete.main,
                                  borderRadius: "5px",
                                  width: "36px",
                                  height: "33px",
                                  padding: "4px",
                                }}
                              >
                                <img src={TrashIcon} alt="Delete" style={{ width: "20px", height: "22px", filter: "brightness(0) invert(1)" }} />
                              </IconButton>
                            </div>
                            <div style={{ display: "flex", gap: "4px" }}>
                              <IconButton
                                size="small"
                                onClick={() => handleMoveBanner(index, 'left')}
                                disabled={index === 0}
                                style={{
                                  backgroundColor: index === 0 ? "#D9D9D9" : theme.palette.primary.main,
                                  color: index === 0 ? "#666" : "white",
                                  borderRadius: "5px",
                                  minWidth: "29px",
                                  width: "29px",
                                  height: "26px",
                                  padding: "4px",
                                }}
                              >
                                <ArrowBackIosIcon style={{ fontSize: "12px", marginLeft: "4px" }} />
                              </IconButton>
                              <IconButton
                                size="small"
                                onClick={() => handleMoveBanner(index, 'right')}
                                disabled={index === bannersData.length - 1}
                                style={{
                                  backgroundColor: index === bannersData.length - 1 ? "#D9D9D9" : theme.palette.primary.main,
                                  color: index === bannersData.length - 1 ? "#666" : "white",
                                  borderRadius: "5px",
                                  minWidth: "29px",
                                  width: "29px",
                                  height: "26px",
                                  padding: "4px",
                                }}
                              >
                                <ArrowForwardIosIcon style={{ fontSize: "12px" }} />
                              </IconButton>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          onClick={() => handleOpenBannerModal(index + 1)}
                          style={{
                            backgroundColor: "#FFFFFF",
                            border: `2px solid ${theme.palette.primary.main}`,
                            borderRadius: "10px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "108px",
                            boxSizing: "border-box",
                            cursor: "pointer",
                            padding: "22px 12px",
                            gap: "10px",
                          }}
                        >
                          <img
                            src={UploadRoundIcon}
                            alt="Upload"
                            style={{ width: "36px", height: "36px" }}
                          />
                          <p
                            style={{
                              color: theme.palette.primary.main,
                              fontSize: "20px",
                              fontWeight: 600,
                              margin: 0,
                              lineHeight: "24px",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {enumStrings.manageChamberEngage.categoryAdvertisingBanners.uploadBanner}
                          </p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                {/* Approved/Not Approved status row */}
                <div className={classes.bannerStatusRow}>
                  {bannersData.map((banner, index) => {
                    const isApproved = (banner.image || banner.videoUrl) ? !banner.waitingForApproval : false;
                    const statusColor = isApproved ? theme.palette.success.main : (theme.palette as any).delete.main;
                    return (
                      <div
                        key={`status-${index}`}
                        style={{
                          flex: "1 1 0",
                          minWidth: 0,
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {(banner.image || banner.videoUrl) && (
                          <div
                            style={{ display: "flex", alignItems: "center", gap: "16px", cursor: "pointer" }}
                            onClick={() => handleToggleBannerApproval(index)}
                          >
                            <span
                              style={{
                          
                                fontWeight: 600,
                                fontSize: "14px",
                                lineHeight: "24px",
                                color: statusColor,
                              }}
                            >
                              {isApproved
                                ? enumStrings.manageChamberEngage.categoryAdvertisingBanners.approvedStatus
                                : enumStrings.manageChamberEngage.categoryAdvertisingBanners.notApprovedStatus}
                            </span>
                            {/* Toggle indicator */}
                            <div
                              style={{
                                width: "36px",
                                height: "18px",
                                borderRadius: "9px",
                                backgroundColor: isApproved ? "rgba(0, 182, 33, 0.13)" : "rgba(237, 28, 36, 0.13)",
                                border: `0.5px solid ${statusColor}`,
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div
                                style={{
                                  width: "14px",
                                  height: "14px",
                                  borderRadius: "50%",
                                  backgroundColor: statusColor,
                                  position: "absolute",
                                  left: isApproved ? "19px" : "3px",
                                  transition: "left 0.3s ease",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {isApproved ? (
                                  <svg width="8" height="8" viewBox="0 0 24 24" fill="white">
                                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                  </svg>
                                ) : (
                                  <svg width="8" height="2" viewBox="0 0 8 2" fill="white">
                                    <rect width="8" height="2" rx="1" />
                                  </svg>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>

                {/* Preview Banners Button */}
                {activeBanners.length > 0 && (
                  <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                    <Button
                      variant="contained"
                      onClick={() => setBannerPreviewOpen(true)}
                      style={{
                        backgroundColor: "#333",
                        color: "white",
                        fontSize: "16px",
                        fontWeight: "bold",
                        borderRadius: "25px",
                        padding: "12px 40px",
                        textTransform: "none",
                      }}
                    >
                      {enumStrings.createMemberForm.previewBannersButton}
                    </Button>
                  </div>
                )}

                <BannerPreviewModal
                  open={bannerPreviewOpen}
                  onClose={() => setBannerPreviewOpen(false)}
                  banners={activeBanners}
                  phoneMockupImage={CategoryBannerPhoneMockup}
                />

                {/* Auto Approve Toggle */}
                <AutoApproveBannerContentToggle
                  checked={!effectiveAutoApproveBannerContentUpdate}
                  onChange={(checked) => handleAutoApproveBannerContentUpdate(!checked)}
                  disabled={changeAutoApprovalForBannerContentOfCategoryAdvertisingBannerLoading}
                />
                {/* Close Button */}
                <div style={{ display: "flex", justifyContent: "center", marginTop: "24px" }}>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: (theme.palette as any).delete.main,
                      color: "white",
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: "Montserrat, sans-serif",
                      borderRadius: "22px",
                      padding: "8px 12px",
                      textTransform: "uppercase",
                      boxShadow: "none",
                      minWidth: "132px",
                      height: 31,
                      lineHeight: "15px",
                    }}
                    onClick={closeDropDownTable}
                  >
                    {enumStrings.manageChamberEngage.categoryAdvertisingBanners.close}
                  </Button>
                </div>
                {/* Banner Upload Modal */}
                <BannerUploadModal
                  open={bannerModalOpen}
                  onClose={() => setBannerModalOpen(false)}
                  bannerIndex={currentBannerIndex}
                  initialData={bannersData[currentBannerIndex - 1] || { image: null, videoUrl: null, redirectUrl: null }}
                  onSave={handleSaveBanner}
                />
                {/* Delete Banner Modal */}
                <DeleteBannerModal
                  open={deleteBannerIndex !== null}
                  onClose={() => setDeleteBannerIndex(null)}
                  onDelete={() => {
                    if (deleteBannerIndex !== null) {
                      handleDeleteBanner(deleteBannerIndex);
                      setDeleteBannerIndex(null);
                    }
                  }}
                />
              </div>
            </div>
          </Collapse>
        </TableCell>
      </TableRow >
    <SuccessDialog
      open={rowDialogState.open}
      onClose={() => setRowDialogState(prev => ({ ...prev, open: false }))}
      message={rowDialogState.message}
      variant={rowDialogState.variant}
      autoDismissMs={20000}
    />
    </>
  );
}

function FullPageManageAllCategoryAdvertisingBannersForChammberCategoryAdvertisingBannersTable({
  allCategoryAdvertisingBannersForChammberData,
  allChamberMemberData,
  allChamberMembersIdToName,
}: {
  allCategoryAdvertisingBannersForChammberData: AllTableAllCategoryAdvertisingBannersForChammberDataType;
  allChamberMemberData: GetAllChamberMembersQuery;
  allChamberMembersIdToName: { [key: string]: CategoryBannerMember };
}) {
  const classes = useStyles();
  const enumStrings = useEnumStrings();
  const [order, setOrder] = React.useState<Order>("asc");
  const [orderBy, setOrderBy] = React.useState<string>("chamberMemberName");

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: string
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const [searchInput, setSearchInput] = React.useState("");
  const [categoryFilter, setCategoryFilter] = React.useState("all");
  const [statusFilter, setStatusFilter] = React.useState("all");

  const handleChange = (e: any) => {
    e.preventDefault();
    setSearchInput(e.target.value);
  };

  const handleClearFilters = () => {
    setSearchInput("");
    setCategoryFilter("all");
    setStatusFilter("all");
  };

  const uniqueCategories = React.useMemo(() => {
    if (!allCategoryAdvertisingBannersForChammberData) return [];
    const categories = new Set(
      allCategoryAdvertisingBannersForChammberData.map(
        (i) => i.humanReadableCategoryName
      )
    );
    return Array.from(categories).sort();
  }, [allCategoryAdvertisingBannersForChammberData]);

  const allTableAllCategoryAdvertisingBannersForChammberData: AllTableAllCategoryAdvertisingBannersForChammberDataType =
    React.useMemo(() => {
      if (!allCategoryAdvertisingBannersForChammberData) {
        return [];
      }

      let filteredData = allCategoryAdvertisingBannersForChammberData.slice();

      // Filter by search input (company name)
      if (searchInput.length > 0) {
        filteredData = filteredData.filter((i) => {
          const companyName = allChamberMembersIdToName[i.bannerSettings?.activationInfo?.chamberMemberId || ""]?.name || "";
          return companyName.toLowerCase().match(searchInput.toLowerCase());
        });
      }

      // Filter by category
      if (categoryFilter !== "all") {
        filteredData = filteredData.filter(
          (i) => i.humanReadableCategoryName === categoryFilter
        );
      }

      // Filter by status
      if (statusFilter !== "all") {
        filteredData = filteredData.filter(
          (i) => i.availability === statusFilter
        );
      }

      return filteredData;
    }, [allCategoryAdvertisingBannersForChammberData, searchInput, categoryFilter, statusFilter, allChamberMembersIdToName]);

  const visibleRows = React.useMemo(
    () =>
      stableSort(
        allTableAllCategoryAdvertisingBannersForChammberData,
        getComparator(order, orderBy)
      ),
    [allTableAllCategoryAdvertisingBannersForChammberData, order, orderBy]
  );

  const headCells: HeadCell[] = [
    {
      id: "humanReadableCategoryName",
      label: enumStrings.manageChamberEngage.tableHeaders.category,
      description: enumStrings.manageChamberEngage.tableHeaders.categorySubtitle,
    },
    {
      id: "availability",
      label: enumStrings.manageChamberEngage.tableHeaders.bannerStatus,
      description: enumStrings.manageChamberEngage.tableHeaders.bannerStatusSubtitle,
    },
    {
      id: "memberCompany",
      label: enumStrings.manageChamberEngage.tableHeaders.memberCompanyHeader,
      description: enumStrings.manageChamberEngage.tableHeaders.memberCompanySubtitle,
    },
    {
      id: "action",
      label: enumStrings.manageChamberEngage.tableHeaders.action,
      description: enumStrings.manageChamberEngage.tableHeaders.actionSubtitle,
      sortable: false,
    },
    {
      id: "bannersFee",
      label: enumStrings.manageChamberEngage.tableHeaders.bannersFee,
      description: enumStrings.manageChamberEngage.tableHeaders.bannersFeeSubtitle,
      sortable: false,
    },
    {
      id: "startDate",
      label: enumStrings.manageChamberEngage.tableHeaders.startDate,
      description: enumStrings.manageChamberEngage.tableHeaders.startDateSubtitle,
    },
    {
      id: "endDate",
      label: enumStrings.manageChamberEngage.tableHeaders.endDate,
      description: enumStrings.manageChamberEngage.tableHeaders.endDateSubtitle,
    },
    {
      id: "viewCloseButton",
      label: enumStrings.manageChamberEngage.tableHeaders.viewBannerInfo,
      description: enumStrings.manageChamberEngage.tableHeaders.viewBannerInfoSubtitle,
      sortable: false,
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <div className={classes.searchContainer}>
        <TextField
          className={classes.searchBar}
          placeholder={enumStrings.manageChamberEngage.searchByCompanyName}
          variant="outlined"
          size="small"
          value={searchInput}
          onChange={handleChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon style={{ color: "#999" }} />
              </InputAdornment>
            ),
          }}
        />

        <Select
          className={classes.filterSelect}
          value={categoryFilter}
          onChange={(e) => setCategoryFilter(e.target.value as string)}
          variant="outlined"
          displayEmpty
          style={{ color: categoryFilter === "all" ? "#9E9E9E" : "#000" }}
          startAdornment={
            <InputAdornment position="start">
              <img src={FilterIcon} alt="Filter" style={{ width: "18px", height: "18px", marginRight: "8px" }} />
            </InputAdornment>
          }
        >
          <MenuItem value="all">{categoryFilter !== "all" ? enumStrings.manageChamberEngage.clearCategory : enumStrings.manageChamberEngage.filterByCategory}</MenuItem>
          {uniqueCategories.map((cat) => (
            <MenuItem key={cat} value={cat}>
              {cat}
            </MenuItem>
          ))}
        </Select>

        <Select
          className={classes.filterSelect}
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value as string)}
          variant="outlined"
          displayEmpty
          style={{ color: statusFilter === "all" ? "#9E9E9E" : "#000" }}
          startAdornment={
            <InputAdornment position="start">
              <img src={FilterIcon} alt="Filter" style={{ width: "18px", height: "18px", marginRight: "8px" }} />
            </InputAdornment>
          }
        >
          <MenuItem value="all">{statusFilter !== "all" ? enumStrings.manageChamberEngage.clearStatus : enumStrings.manageChamberEngage.filterByStatus}</MenuItem>
          <MenuItem value="unsold">{enumStrings.manageChamberEngage.unsold}</MenuItem>
          <MenuItem value="sold">{enumStrings.manageChamberEngage.sold}</MenuItem>
          <MenuItem value="soldAndResold">{enumStrings.manageChamberEngage.soldAndResold}</MenuItem>
        </Select>

        <Button
          variant="contained"
          onClick={handleClearFilters}
          style={{
            backgroundColor: (theme.palette as any).delete.main,
            color: "#FFFFFF",
            borderRadius: "22px",
            padding: "8px 12px",
            fontFamily: "Montserrat",
            fontWeight: 500,
            fontSize: "12px",
            lineHeight: "15px",
            textTransform: "none",
            textAlign: "center",
            boxShadow: "none",
            minWidth: "unset",
            whiteSpace: "nowrap",
          }}
        >
          {enumStrings.manageChamberEngage.clearAllFilters}
        </Button>
      </div>
      {/* Desktop table */}
      <div className={classes.desktopTableWrapper}>
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            borderRadius: "12px",
            boxShadow: "none",
            border: "1px solid #E8E8E8",
            backgroundColor: "#ffffff",
          }}
        >
          <TableContainer sx={{ maxHeight: "80vh", backgroundColor: "#ffffff", overflowX: "auto" }}>
            <Table
              sx={{
                minWidth: 750,
                width: "100%",
              }}
              aria-labelledby="tableTitle"
              size={"medium"}
              stickyHeader
            >
              <FullPageAllCategoryAdvertisingBannersForChammberTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                headCells={headCells}
              />
              <TableBody>
                {visibleRows.map((categoryAdvertisingBanner, index) => (
                  <IndividualTableRow
                    key={categoryAdvertisingBanner.id}
                    index={index}
                    humanReadableCategoryName={
                      categoryAdvertisingBanner.humanReadableCategoryName
                    }
                    categoryAdvertisingBanner={categoryAdvertisingBanner}
                    allChamberMemberData={allChamberMemberData}
                    allChamberMembersIdToName={allChamberMembersIdToName}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>

      {/* Mobile card list */}
      <div className={classes.mobileCardWrapper}>
        {visibleRows.map((categoryAdvertisingBanner) => (
          <IndividualMobileCard
            key={categoryAdvertisingBanner.id}
            categoryAdvertisingBanner={categoryAdvertisingBanner}
            allChamberMemberData={allChamberMemberData}
            allChamberMembersIdToName={allChamberMembersIdToName}
          />
        ))}
      </div>
    </Box>
  );
}

function CategoryBannerActivationForm({
  chamberInfo,
  allChamberMembers,
  allChamberMemberData,
  categoryIdToHumanReadableName,
  allCategories,
  allCategoryAdvertisingBannersForChammberData,
}: {
  chamberInfo: { chamberEngageSettings: Pick<ChamberEngageSettingsReturn, "isActive"> & Partial<Pick<ChamberEngageSettingsReturn,
    "categoryAdvertisingBannersFeeOptions" | "categoryAdvertisingBannersActivationFeeCpaSplitPercentage">> } | undefined;
  allChamberMembers: CategoryBannerMember[];
  allChamberMemberData: GetAllChamberMembersQuery | undefined;
  categoryIdToHumanReadableName: { [key: string]: string };
  allCategories: any[];
  allCategoryAdvertisingBannersForChammberData: AllTableAllCategoryAdvertisingBannersForChammberDataType;
}) {
  const enumStrings = useEnumStrings();
  const classes = useStyles();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const preSelectedCategoryId = (location?.state as any)?.preSelectedCategoryId || "";
  const [selectedCategory, setSelectedCategory] = useState<string>(preSelectedCategoryId);
  const [selectedMember, setSelectedMember] = useState<string>("");
  const [startDate, setStartDate] = useState<dayjs.Dayjs | null>(null);
  const [endDate, setEndDate] = useState<dayjs.Dayjs | null>(null);
  const [isActivating, setIsActivating] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [autoApproveBannerContent, setAutoApproveBannerContent] = useState(true);

  const graphqlChamberIdVariableObjForRootAdmin =
    useGetGraphqlChamberIdVariableObjForRootAdmin();

  const [activateBannerForCategoryAdvertisingBanner] =
    useActivateBannerForCategoryAdvertisingBannerMutation();

  const feeOptions = chamberInfo?.chamberEngageSettings?.categoryAdvertisingBannersFeeOptions;
  const annualFee = feeOptions?.[0]?.bannerFeeInDollars || 1000;
  const splitPercentage = chamberInfo?.chamberEngageSettings?.categoryAdvertisingBannersActivationFeeCpaSplitPercentage ?? 1;
  const activationFee = Number((annualFee * (splitPercentage / 100)).toFixed(0)) || 0;

  // Update End Date when Start Date changes
  const handleStartDateChange = (newValue: dayjs.Dayjs | null) => {
    setStartDate(newValue);
    if (newValue) {
      const months = feeOptions?.[0]?.timeLengthInMonths || 12;
      setEndDate(newValue.add(months, "month"));
    } else {
      setEndDate(null);
    }
  };

  const handleClearAll = () => {
    setSelectedCategory("");
    setSelectedMember("");
    setStartDate(null);
    setEndDate(null);
  };

  const handleActivate = async () => {
    if (!selectedMember || !selectedCategory || !startDate) {
      setErrorMessage(enumStrings.manageMemberProfile.pleaseSelectMemberAndDate);
      setShowErrorDialog(true);
      return;
    }

    if (!feeOptions || feeOptions.length === 0) {
      setErrorMessage(enumStrings.manageMemberProfile.failedToActivate);
      setShowErrorDialog(true);
      return;
    }

    setIsActivating(true);
    try {
      const bannerFeeOptionSetAtActivationTime: CategoryAdvertisingBannersFeeOptionsInput = {
        timeLengthInMonths: feeOptions[0].timeLengthInMonths,
        bannerFeeInDollars: feeOptions[0].bannerFeeInDollars,
      };

      await activateBannerForCategoryAdvertisingBanner({
        variables: {
          ...graphqlChamberIdVariableObjForRootAdmin,
          categoryId: selectedCategory as ChamberMemberCategory,
          activationInfo: {
            activationStartDateUtcMilli: startDate.startOf("day").valueOf(),
            bannerFeeOptionSetAtActivationTime,
            chamberMemberId: selectedMember,
            autoApproveBannerContentUpdate: autoApproveBannerContent,
          },
        },
        refetchQueries: [
          {
            query: GetAllCategoryAdvertisingBannersForChamberDocument,
            variables: {
              ...graphqlChamberIdVariableObjForRootAdmin,
            },
          },
        ],
        awaitRefetchQueries: true,
      });

      setShowSuccessDialog(true);
      handleClearAll();
    } catch (error) {
      console.error("Activation failed:", error);
      setErrorMessage(enumStrings.manageMemberProfile.failedToActivate);
      setShowErrorDialog(true);
    } finally {
      setIsActivating(false);
    }
  };

  // Filter categories to only show unsold ones
  const availableCategories = useMemo(() => {
    if (!allCategoryAdvertisingBannersForChammberData) return allCategories;
    const soldCategoryIds = new Set(
      allCategoryAdvertisingBannersForChammberData
        .filter((banner) => banner.availability !== "unsold")
        .map((banner) => banner.categoryId)
    );
    return allCategories.filter((category) => !soldCategoryIds.has(category.id));
  }, [allCategories, allCategoryAdvertisingBannersForChammberData]);

  const selectedMemberName = selectedMember
    ? allChamberMembers.find(m => m.id === selectedMember)?.name || "{Member Company Name}"
    : "{Member Company Name}";

  const infoTexts = [
    enumStrings.manageChamberEngage.activationForm.emailNotification60Days + " " + enumStrings.manageChamberEngage.activationForm.reactivateInstructions,
    enumStrings.manageChamberEngage.activationForm.autoDeactivate365Days,
  ];

  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: isMobile ? "20px" : "40px", width: "100%", boxSizing: "border-box" }}>
      <div
        style={{
          width: "1250px",
          maxWidth: "100%",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFFFFF",
            borderRadius: isMobile ? 0 : "20px",
            padding: isMobile ? "14px" : "clamp(16px, 4vw, 45px)",
          }}
        >
          <div
            style={{
              border: isMobile ? "none" : "1px solid #9E9E9E",
              borderRadius: isMobile ? 0 : "16px",
              padding: isMobile ? 0 : "clamp(16px, 4vw, 45px)",
              width: "100%",
              maxWidth: "1160px",
              margin: "0 auto",
              fontFamily: "Inter, sans-serif",
              boxSizing: "border-box",
            }}
          >
            {/* Form Fields Container — REVERT: change maxWidth back to "574px" to restore narrow form fields */}
            <div style={{ maxWidth: "700px", margin: "0 auto" }}>
              {/* Member Company Name */}
              <div style={{ marginBottom: "20px" }}>
                <FormLabel
                  label={enumStrings.manageChamberEngage.activationForm.chooseMember}
                  required={true}
                  showInfoIcon={false}
                />
                <FormDescription>
                  {enumStrings.manageChamberEngage.activationForm.selectMemberForBanner}
                </FormDescription>
                <ChamberMemberSelector
                  chamberMemberId={selectedMember || null}
                  setChamberMemberId={setSelectedMember}
                  allChamberMemberData={allChamberMemberData}
                  fullWidth
                  hideTooltip
                  hideLabel
                />
              </div>

              {/* Activate Category */}
              <div style={{ marginBottom: "20px" }}>
                <FormLabel
                  label={enumStrings.manageChamberEngage.activationForm.chooseCategory}
                  required={true}
                  showInfoIcon={false}
                />
                <FormDescription>
                  {enumStrings.manageChamberEngage.activationForm.selectCategoryDescription}{" "}
                  <strong>{enumStrings.manageChamberEngage.activationForm.selectCategoryDescriptionBold}</strong>
                </FormDescription>
                <FormControl fullWidth variant="outlined">
                  <Select
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value as string)}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Select Category' }}
                    style={{
                      ...activationFormStyles.inputField,
                      border: "1px solid #000000",
                      borderRadius: "8px",
                    }}
                  >
                    <MenuItem value="" disabled>
                      <span style={{ color: "#333333" }}>{enumStrings.manageChamberEngage.activationForm.selectCategory}</span>
                    </MenuItem>
                    {availableCategories.map((category) => (
                      <MenuItem key={category.id} value={category.id}>
                        {category.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>

              {/* Start Date */}
              <div style={{ marginBottom: "20px" }}>
                <FormLabel
                  label={enumStrings.manageChamberEngage.startDate}
                  required={false}
                  showInfoIcon={false}
                />
                <MuiThemeProvider theme={goldDatePickerTheme}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDatePicker
                      value={startDate}
                      onChange={handleStartDateChange}
                      format="MMM DD, YYYY"
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          variant: "outlined",
                          placeholder: enumStrings.manageChamberEngage.activationForm.chooseStartDate,
                          InputProps: {
                            style: activationFormStyles.inputField,
                            startAdornment: (
                              <EventIcon style={{ color: "#000000", marginRight: "8px", fontSize: "20px" }} />
                            ),
                          },
                          sx: {
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "#000000",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: theme.palette.primary.main,
                              },
                            },
                          },
                        },
                        dialog: {
                          sx: {
                            "& .MuiPickersDay-root.Mui-selected": {
                              backgroundColor: `${theme.palette.primary.main} !important`,
                            },
                            "& .MuiPickersDay-root:hover": {
                              backgroundColor: "rgba(225, 167, 49, 0.1)",
                            },
                            "& .MuiPickersDay-today": {
                              borderColor: `${theme.palette.primary.main} !important`,
                            },
                            "& .MuiButton-textPrimary": {
                              color: `${theme.palette.primary.main} !important`,
                            },
                            "& .MuiPickersYear-yearButton.Mui-selected": {
                              backgroundColor: `${theme.palette.primary.main} !important`,
                            },
                            "& .MuiPickersMonth-monthButton.Mui-selected": {
                              backgroundColor: `${theme.palette.primary.main} !important`,
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </MuiThemeProvider>
              </div>

              {/* End Date (Auto-calculated) */}
              <div style={{ marginBottom: "30px" }}>
                <FormLabel
                  label={`${enumStrings.manageChamberEngage.expiryDate} ${enumStrings.manageChamberEngage.activationForm.endDateAutoCalculated}`}
                  required={false}
                  showInfoIcon={false}
                />
                <MuiThemeProvider theme={goldDatePickerTheme}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDatePicker
                      value={endDate}
                      readOnly
                      disabled
                      format="MMM DD, YYYY"
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          variant: "outlined",
                          placeholder: enumStrings.manageChamberEngage.activationForm.endDateAutoCalculated,
                          InputProps: {
                            style: {
                              ...activationFormStyles.inputField,
                              backgroundColor: "#f5f5f5",
                            },
                            startAdornment: (
                              <EventIcon style={{ color: "#000000", marginRight: "8px", fontSize: "20px" }} />
                            ),
                          },
                          sx: {
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "#000000",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: theme.palette.primary.main,
                              },
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </MuiThemeProvider>
              </div>
            </div>

            {/* Info Text - inside solid box, above auto approve toggle */}
            <div style={{ marginTop: "10px", maxWidth: "700px", margin: "10px auto 0 auto" }}>
              <InfoTextSection texts={infoTexts} />
            </div>

            {/* Auto Approve Banner Content Toggle - inside the solid box */}
            <AutoApproveBannerContentToggle
              checked={!autoApproveBannerContent}
              onChange={(checked) => setAutoApproveBannerContent(!checked)}
            />

            {/* Annual Fee Section - inside the solid box */}
            <div style={{ marginTop: "30px", marginBottom: "30px" }}>
              <AnnualFeeDisplay amount={annualFee} label={enumStrings.manageChamberEngage.categoryDirectoryAdvertisingFee} showPerYear />
            </div>

            {/* Fee Table - inside the solid box — REVERT: change maxWidth back to "900px" */}
            <div style={{ marginBottom: isMobile ? "20px" : "30px", maxWidth: "700px", margin: isMobile ? "0 auto 20px auto" : "0 auto 30px auto" }}>
              <table style={{
                width: "100%",
                borderCollapse: "separate",
                borderSpacing: 0,
                overflow: "hidden",
                borderRadius: "8px",
                tableLayout: "fixed",
              }}>
                <thead>
                  <tr>
                    <th style={{
                      backgroundColor: theme.palette.primary.main,
                      color: "white",
                      padding: isMobile ? "10px 8px" : "16px 20px",
                      textAlign: "center",
                      fontSize: isMobile ? "13px" : "22px",
                      fontWeight: 700,
                      borderTopLeftRadius: "8px",
                      border: "none",
                      lineHeight: isMobile ? "1.2" : "normal",
                    }}>
                      {enumStrings.manageChamberEngage.nonDuesRevenue}
                    </th>
                    <th style={{
                      backgroundColor: theme.palette.primary.main,
                      color: "white",
                      padding: isMobile ? "10px 8px" : "16px 20px",
                      textAlign: "center",
                      fontSize: isMobile ? "13px" : "22px",
                      fontWeight: 700,
                      borderTopRightRadius: "8px",
                      border: "none",
                      lineHeight: isMobile ? "1.2" : "normal",
                    }}>
                      {enumStrings.manageChamberEngage.activationFee}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{
                      backgroundColor: "#FFF",
                      border: "1px solid #E0E0E0",
                      borderTop: "none",
                      padding: isMobile ? "12px 8px" : "16px 20px",
                      fontSize: isMobile ? "18px" : "32px",
                      fontWeight: 500,
                      color: "#333",
                      textAlign: "center"
                    }}>
                      ${annualFee - activationFee}
                    </td>
                    <td style={{
                      backgroundColor: "#FFF",
                      border: "1px solid #E0E0E0",
                      borderTop: "none",
                      padding: isMobile ? "12px 8px" : "16px 20px",
                      fontSize: isMobile ? "18px" : "32px",
                      fontWeight: 500,
                      color: "#333",
                      textAlign: "center"
                    }}>
                      ${activationFee}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Invoice Note - inside the solid box — REVERT: change maxWidth back to "800px" */}
            <p
              style={{

                fontSize: isMobile ? "14px" : "18px",
                lineHeight: isMobile ? "20px" : "28px",
                fontWeight: 400,
                color: "#000000",
                textAlign: "left",
                maxWidth: "700px",
                margin: isMobile ? "0 auto 20px auto" : "0 auto 30px auto",
              }}
            >
              {enumStrings.manageChamberEngage.categoryInvoicingDescription
                .replace("{{memberName}}", selectedMemberName)
                .replace("{{annualFee}}", String(annualFee))}
              <br />
              <span style={{ fontWeight: 700 }}>
                {enumStrings.manageChamberEngage.categoryInvoicingDescriptionBold
                  .replace("{{activationFee}}", String(activationFee))}
              </span>
            </p>

            {/* Activate Button - inside the solid box */}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={handleActivate}
                disabled={isActivating}
                style={{

                  backgroundColor: theme.palette.success.main,
                  color: "#FFFFFF",
                  fontWeight: 700,
                  borderRadius: "12px",
                  padding: isMobile ? "12px 20px" : "15px 40px",
                  textTransform: "none" as const,
                  fontSize: isMobile ? "16px" : "20px",
                  minWidth: isMobile ? "auto" : "200px",
                  width: isMobile ? "100%" : "auto",
                  height: isMobile ? "46px" : "50px",
                  boxShadow: "none",
                  letterSpacing: "-0.01em",
                  lineHeight: "150%",
                }}
              >
                {isActivating ? <CircularProgress size={24} color="inherit" /> : "ACTIVATE"}
              </Button>
            </div>

            {/* Success Dialog */}
            <SuccessDialog
              open={showSuccessDialog}
              onClose={() => setShowSuccessDialog(false)}
              message={enumStrings.manageChamberEngage.categoryBannerActivatedSuccess}
              autoDismissMs={20000}
            />
            <SuccessDialog
              open={showErrorDialog}
              onClose={() => setShowErrorDialog(false)}
              message={errorMessage}
              variant="error"
              autoDismissMs={5000}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

const ManageAllCategoryAdvertisingBannersForChammberCategoryAdvertisingBanners =
  (): ReactElement => {
    const classes = useStyles();

    const graphqlChamberIdVariableObjForRootAdmin =
      useGetGraphqlChamberIdVariableObjForRootAdmin();

    let { data: allCategoryAdvertisingBannersForChammber, loading } =
      useGetAllCategoryAdvertisingBannersForChamberQuery({
        fetchPolicy: "network-only",
        variables: {
          ...graphqlChamberIdVariableObjForRootAdmin,
        },
      });

    const [
      allCategoryAdvertisingBannersForChammberData,
      setAllCategoryAdvertisingBannersForChammberData,
    ] =
      React.useState<AllTableAllCategoryAdvertisingBannersForChammberDataType>(
        []
      );

    const [allChamberMemberData, setAllChamberMemberData] =
      useState<GetAllChamberMembersQuery>({});

    const [allChamberMembersIdToName, setAllChamberMembersIdToName] = useState<{
      [key: string]: CategoryBannerMember;
    }>({});

    const [isLoading, setIsLoading] = useState(true);
    const [showComingSoon, setShowComingSoon] = useState(false);

    const { categoryIdToHumanReadableName, allCategories } =
      useGetCategoryIdToHumanReadableName();

    const {
      state: { userType },
    } = useContext(UserTypeContext);
    const chamberInfo = useGetChamberFromUserIdInAuth();
    const location = useLocation();
    const chamberIdToUse = useMemo(() => {
      if (userType === UserType.RootAdmin) {
        return (
          (location.state || { chamberId: undefined }) as {
            chamberId: string | undefined;
          }
        ).chamberId;
      }
      return chamberInfo?.id;
    }, [chamberInfo?.id, location?.state, userType]);
    const { data: allChamberMemberDataFromServer } =
      useGetAllChamberMembersQuery({
        variables: { chamberId: chamberIdToUse || "" },
        skip: !chamberIdToUse,
        fetchPolicy: "cache-and-network",
      });

    useEffect(() => {
      const getAllCategoryAdvertisingBannersForChammberstats = async () => {
        if (
          !allChamberMemberDataFromServer?.getAllChamberMembers ||
          !allCategoryAdvertisingBannersForChammber?.getAllCategoryAdvertisingBannersForChamber ||
          !categoryIdToHumanReadableName ||
          !allCategories
        ) {
          setIsLoading(true);
          setAllCategoryAdvertisingBannersForChammberData([]);
          setAllChamberMemberData({});
          setAllChamberMembersIdToName({});
          return;
        }

        const allCategoryAdvertisingBannersForChammberArr: AllTableAllCategoryAdvertisingBannersForChammberDataType =
          [];

        for (const categoryAdvertisingBanner of allCategoryAdvertisingBannersForChammber
          .getAllCategoryAdvertisingBannersForChamber
          .categoryAdvertisingBanners) {
          allCategoryAdvertisingBannersForChammberArr.push({
            id: categoryAdvertisingBanner.categoryId,
            ...categoryAdvertisingBanner,
            humanReadableCategoryName:
              categoryIdToHumanReadableName[
              categoryAdvertisingBanner.categoryId
              ],
            logo: categoryIdToLogo[categoryAdvertisingBanner.categoryId],
            availability: categoryAdvertisingBanner?.bannerSettings
              ?.activationInfo
              ? categoryAdvertisingBanner?.bannerSettings?.reactivationInfo
                ? "soldAndResold"
                : "sold"
              : "unsold",
            waitingForApproval:
              (
                categoryAdvertisingBanner?.bannerSettings?.activationInfo
                  ?.banner || []
              ).some((banner) => banner?.waitingForApprovalByChamberAdmin) ||
              false,
          });
        }

        setAllCategoryAdvertisingBannersForChammberData(
          allCategoryAdvertisingBannersForChammberArr
            .slice()
            // sort bsed on order of categoryIds in allCategories
            .sort((a, b) => {
              return (
                allCategories.findIndex(
                  (category) => category.id === a.categoryId
                ) -
                allCategories.findIndex(
                  (category) => category.id === b.categoryId
                )
              );
            })
            // then put availability = "soldAndResold" first
            .sort((a, b) => {
              if (
                a.availability === "soldAndResold" &&
                b.availability !== "soldAndResold"
              ) {
                return -1;
              }
              if (
                a.availability !== "soldAndResold" &&
                b.availability === "soldAndResold"
              ) {
                return 1;
              }
              return 0;
            })
            // then put availability = "sold" first
            .sort((a, b) => {
              if (a.availability === "sold" && b.availability !== "sold") {
                return -1;
              }
              if (a.availability !== "sold" && b.availability === "sold") {
                return 1;
              }
              return 0;
            })
            // then put the "waitingForApproval=true" first
            .sort((a, b) => {
              if (a.waitingForApproval && !b.waitingForApproval) {
                return -1;
              }
              if (!a.waitingForApproval && b.waitingForApproval) {
                return 1;
              }
              return 0;
            })
        );

        // set allChamberMemberData
        setAllChamberMemberData(allChamberMemberDataFromServer);

        // set allChamberMembersIdToName
        const allChamberMembersIdToNameObj: { [key: string]: CategoryBannerMember } = {};
        for (const chamberMemberObj of allChamberMemberDataFromServer.getAllChamberMembers) {
          allChamberMembersIdToNameObj[chamberMemberObj.id] = chamberMemberObj;
        }
        setAllChamberMembersIdToName(allChamberMembersIdToNameObj);

        setIsLoading(false);
      };

      getAllCategoryAdvertisingBannersForChammberstats();
    }, [
      loading,
      allCategories,
      allCategoryAdvertisingBannersForChammber?.getAllCategoryAdvertisingBannersForChamber,
      allChamberMemberDataFromServer,
      allChamberMemberDataFromServer?.getAllChamberMembers,
      categoryIdToHumanReadableName,
    ]);
    const enumStrings = useEnumStrings();

    const rootAdminObj = // @ts-ignore
      enumStrings?.groups[userType][
      RedirectUri.chamberEngageManageCategoryAdvertisingBanners
      ];

    const history = useHistory();

    // Check if we're on the activate route or manage route
    const isActivateRoute = location.pathname.includes("/activate");
    const isManageRoute = location.pathname.includes("/manage");

    // Determine page title based on route
    const pageTitle = isActivateRoute
      ? enumStrings.manageChamberEngage.activateCategoryTitle
      : isManageRoute
      ? enumStrings.manageChamberEngage.manageActivationsTitle
      : rootAdminObj.title;
    const pageDescription = isActivateRoute
      ? enumStrings.manageChamberEngage.activateCategoryDescription
      : isManageRoute
      ? enumStrings.manageChamberEngage.manageActivationsDescription
      : rootAdminObj.description;

    return (
      <div style={{ overflowX: "hidden" }}>
        <div className={classes.headerSection}>
          <div className={classes.titleRow}>
            <h1 className={classes.title}>
              {pageTitle}
              {(location?.state as any)?.chamberName &&
                ` for ${(location?.state as any)?.chamberName}`}
            </h1>
          </div>
          <p className={classes.description}>
            {pageDescription} {enumStrings.watchVideoToLearnHow}
          </p>
          {isActivateRoute && (
            <p className={classes.description} style={{ marginTop: "8px" }}>
              {enumStrings.manageChamberEngage.activateCategoryDescriptionLine2}
            </p>
          )}
          {isManageRoute && (
            <p className={classes.description} style={{ marginTop: "8px" }}>
              {enumStrings.manageChamberEngage.manageActivationsDescriptionLine2}
            </p>
          )}
          <div className={classes.buttonContainer}>
            <VideoTutorialButton
              tutorialUrl="https://share.synthesia.io/embeds/videos/5bf66689-ccd5-4b6d-8f49-d05f809cef74"
            />
            {userType !== UserType.RootAdmin && (
              <ExportButton
                customOnClick={() =>
                  openInstructionPdf(
                    isActivateRoute
                      ? "Activate Category Member Advertising Banner.pdf"
                      : "Manage Category Member Advertising Activations.pdf"
                  )
                }
                disablePadding
                icon={<InfoOutlinedIcon style={{ color: theme.palette.primary.main, marginRight: "10px", width: "24px", height: "24px" }} />}
                label={enumStrings.manageChamberEngage.viewInstructions}
              />
            )}
          </div>
        </div>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            {isActivateRoute ? (
              <CategoryBannerActivationForm
                chamberInfo={chamberInfo}
                allChamberMembers={allChamberMemberData?.getAllChamberMembers || []}
                allChamberMemberData={allChamberMemberData}
                categoryIdToHumanReadableName={categoryIdToHumanReadableName || {}}
                allCategories={allCategories || []}
                allCategoryAdvertisingBannersForChammberData={allCategoryAdvertisingBannersForChammberData}
              />
            ) : isLoading ? (
              <Loader />
            ) : (
              <>
                {allCategoryAdvertisingBannersForChammberData &&
                  allCategoryAdvertisingBannersForChammberData.length > 0 ? (
                  <FullPageManageAllCategoryAdvertisingBannersForChammberCategoryAdvertisingBannersTable
                    allCategoryAdvertisingBannersForChammberData={
                      allCategoryAdvertisingBannersForChammberData
                    }
                    allChamberMemberData={allChamberMemberData}
                    allChamberMembersIdToName={allChamberMembersIdToName}
                  />
                ) : (
                  <div
                    style={{
                      color: "black",
                      textAlign: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      margin: "auto",
                    }}
                  >
                    {enumStrings.manageChamberEngage.loadingChamberMembers}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      <ComingSoonDialog
        open={showComingSoon}
        onClose={() => setShowComingSoon(false)}
      />
      </div>
    );
  };

export default ManageAllCategoryAdvertisingBannersForChammberCategoryAdvertisingBanners;
